const windowWidth = window.innerWidth
// const windowHeight = window.outerHeight
const windowHeight = window.innerHeight
const mainWrapper = document.querySelector('.main')
const APPLY_FORM_HASH = '#free_lesson'
const CERTIFICATE_ID_HASH = '#certificate_id'
const APPLY_FORM_TITLE_SELECTOR = '[data-apply-form-title]'
const APPLY_FORM_SECTION_SELECTOR = '[data-apply-form-section]'
const APPLY_FORM_MEDIA_SELECTOR = '[data-apply-form-media]'
const CERTIFICATE_ID_TARGET_SELECTOR = '[data-certificate-id-target]'
const CURSOR_FOLLOW_WRAPPER_SELECTOR = '[data-cursor-follow]'
const CURSOR_FOLLOW_ICON_SELECTOR = '[data-cursor-follow-icon]'
const CURSOR_FOLLOW_INNER_SELECTOR = '[data-cursor-follow-inner]'
const SPLIT_LINES_SELECTOR = '[data-split-lines]'
const DEFAULT_COURSE_BG_COLOR = '#010101'
let scroll,
    staggerDefault = 0.05,
    durationDefault = 0.6,
    disableBackgroundColor = false,
    pendingApplyFormHashScroll = Boolean(window.__applyFormHashRequested) || window.location.hash === APPLY_FORM_HASH,
    hasEarlyScrollIntent = false,
    isPreloaderHidden = false,
    applyFormNavigationRequestId = 0

function markEarlyScrollIntent() {
    hasEarlyScrollIntent = true
}

window.addEventListener('wheel', markEarlyScrollIntent, { passive: true })
window.addEventListener('touchstart', markEarlyScrollIntent, { passive: true })
window.addEventListener('touchmove', markEarlyScrollIntent, { passive: true })
window.addEventListener('scroll', () => {
    if ((window.scrollY || window.pageYOffset || 0) > 4) {
        markEarlyScrollIntent()
    }
}, { passive: true })

mainWrapper?.addEventListener('scroll', () => {
    if (mainWrapper.scrollTop > 4) {
        markEarlyScrollIntent()
    }
}, { passive: true })

window.addEventListener('keydown', event => {
    if ([' ', 'ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End'].includes(event.key)) {
        markEarlyScrollIntent()
    }
})

CustomEase.create("nbs", "0.625, 0.05, 0, 1")
CustomEase.create('osmoBounce', 'M0,0 C0.18,0.9 0.32,1.1 0.44,1.12 C0.52,1.10 0.60,0.98 0.66,0.96 C0.72,0.95 0.80,1.03 0.85,1.04 C0.92,1.02 0.97,1.0 1,1')
CustomEase.create('bounce2','M0,0 C0.10,0 0.20,0 0.28,0 C0.36,1.7 0.40,1.7 0.42,1.45 C0.48,0.85 0.52,0.9 0.56,1 C0.62,1.35 0.66,1.35 0.68,1.12 C0.76,0.98 0.86,1 1,1')

gsap.defaults({ ease: "nbs", duration: durationDefault })

document.addEventListener('DOMContentLoaded', () => {
    resetScrollToTop()
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
            initScript()
        })
    } else {
        window.addEventListener('load', initScript)
    }
})

function initScript() {
    if (mainWrapper) {
        gsap.set(mainWrapper, { backgroundColor: DEFAULT_COURSE_BG_COLOR })
    }

    initCheckWindowHeight()
    initBasicFunctions()
    initGlobalSplitLines()
    initCountdowns()
	initSmoothScroll()
    runPageEnterAnimation()

    initAccordion()
    initLangSwitcher()
    waveSections()
    formContactPopup()
    initFreeModulePopup()
    menuMobile()
    scrollTriggerAnimations()
    initCursorFollow()
    initLazyVideos()
    initManualToggleVideos()
    initMainVideoButtons()
    initMainVideoPopup()
    initFounderSlider()
    initApplyFormHashNavigation()
}

function initCountdowns(scope = document) {
    const counters = scope.querySelectorAll('[data-time-counter], [data-countdown]')
    if (!counters.length) return

    const DAY_MS = 24 * 60 * 60 * 1000
    const HOUR_MS = 60 * 60 * 1000
    const MINUTE_MS = 60 * 1000
    const SECOND_MS = 1000
    const pad = value => String(Math.max(0, value)).padStart(2, '0')
    const parseNumber = rawValue => {
        if (rawValue === null || rawValue === undefined || rawValue === '') return 0
        const parsed = Number(rawValue)
        return Number.isFinite(parsed) ? parsed : 0
    }
    const parseDateTimeLocal = rawValue => {
        const value = String(rawValue || '').trim()
        if (!value) return NaN

        const match = value.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/)
        if (match) {
            const [, year, month, day, hour, minute, second = '0'] = match
            const date = new Date(
                Number(year),
                Number(month) - 1,
                Number(day),
                Number(hour),
                Number(minute),
                Number(second),
                0
            )

            if (
                date.getFullYear() === Number(year) &&
                date.getMonth() === Number(month) - 1 &&
                date.getDate() === Number(day)
            ) {
                return date.getTime()
            }
        }

        return Date.parse(value)
    }

    const resolveTargetTimestamp = element => {
        const datetimeRaw =
            (element.getAttribute('data-time-datetime') || '').trim() ||
            (element.getAttribute('data-time-until') || '').trim()
        const parsedDateTime = parseDateTimeLocal(datetimeRaw)
        if (Number.isFinite(parsedDateTime)) {
            return parsedDateTime
        }

        const days = Math.max(0, parseNumber(element.getAttribute('data-time-days') || element.getAttribute('data-countdown-days')))
        const hours = Math.max(0, parseNumber(element.getAttribute('data-time-hours')))
        const minutes = Math.max(0, parseNumber(element.getAttribute('data-time-minutes')))
        const seconds = Math.max(0, parseNumber(element.getAttribute('data-time-seconds')))
        const totalOffset =
            (days * DAY_MS) +
            (hours * HOUR_MS) +
            (minutes * MINUTE_MS) +
            (seconds * SECOND_MS)

        return Date.now() + (totalOffset > 0 ? totalOffset : DAY_MS)
    }

    const formatTimeLeft = milliseconds => {
        const totalSeconds = Math.max(0, Math.floor(milliseconds / 1000))
        const days = Math.floor(totalSeconds / 86400)
        const hours = Math.floor((totalSeconds % 86400) / 3600)
        const minutes = Math.floor((totalSeconds % 3600) / 60)
        const seconds = totalSeconds % 60
        return `${pad(days)}:${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
    }

    const entries = []
    const entriesByElement = new Map()

    counters.forEach(counter => {
        if (counter.dataset.countdownBound === '1') return
        counter.dataset.countdownBound = '1'

        const targetTimestamp = resolveTargetTimestamp(counter)
        if (!Number.isFinite(targetTimestamp)) return

        const expiredText =
            counter.getAttribute('data-time-expired-text') ||
            counter.getAttribute('data-countdown-expired-text') ||
            '00:00:00:00'
        const initialDiff = targetTimestamp - Date.now()
        const initialText = initialDiff <= 0 ? expiredText : formatTimeLeft(initialDiff)

        counter.textContent = initialText
        entries.push({
            element: counter,
            targetTimestamp,
            expiredText,
            done: initialDiff <= 0,
            lastText: initialText,
            isVisible: false,
            keepRunningOffscreen: counter.getAttribute('data-time-run-offscreen') === 'true',
        })
        entriesByElement.set(counter, entries[entries.length - 1])
    })

    if (!entries.length) return

    let timeoutId = null
    let disposed = false
    let visibilityObserver = null

    const clearScheduledTick = () => {
        if (timeoutId === null) return
        clearTimeout(timeoutId)
        timeoutId = null
    }

    const render = () => {
        const now = Date.now()
        let hasActiveEntries = false

        entries.forEach(entry => {
            if (entry.done) return
            if (!document.body.contains(entry.element)) {
                entry.done = true
                if (visibilityObserver) {
                    visibilityObserver.unobserve(entry.element)
                }
                return
            }

            if (!entry.keepRunningOffscreen && !entry.isVisible) {
                return
            }

            const diff = entry.targetTimestamp - now
            const nextText = diff <= 0 ? entry.expiredText : formatTimeLeft(diff)
            if (nextText !== entry.lastText) {
                entry.element.textContent = nextText
                entry.lastText = nextText
            }

            if (diff <= 0) {
                entry.done = true
                return
            }

            hasActiveEntries = true
        })

        return hasActiveEntries
    }

    const scheduleTick = () => {
        if (disposed) return
        clearScheduledTick()
        if (document.visibilityState === 'hidden') return

        const msUntilNextSecond = 1000 - (Date.now() % 1000)
        timeoutId = setTimeout(runLoop, Math.max(120, msUntilNextSecond + 8))
    }

    const runLoop = () => {
        if (disposed) return
        const hasActiveEntries = render()
        if (hasActiveEntries) {
            scheduleTick()
        } else {
            clearScheduledTick()
        }
    }

    const onVisibilityChange = () => {
        if (disposed) return
        if (document.visibilityState === 'hidden') {
            clearScheduledTick()
            return
        }
        runLoop()
    }

    if (typeof IntersectionObserver === 'function') {
        visibilityObserver = new IntersectionObserver((observedEntries) => {
            observedEntries.forEach(observerEntry => {
                const item = entriesByElement.get(observerEntry.target)
                if (!item || item.done || item.keepRunningOffscreen) return
                item.isVisible = observerEntry.isIntersecting
            })

            if (document.visibilityState !== 'hidden') {
                runLoop()
            }
        }, {
            root: null,
            threshold: 0,
            rootMargin: '120px 0px 120px 0px',
        })

        entries.forEach(entry => {
            if (entry.keepRunningOffscreen) {
                entry.isVisible = true
                return
            }
            visibilityObserver.observe(entry.element)
        })
    } else {
        entries.forEach(entry => {
            entry.isVisible = true
        })
    }

    document.addEventListener('visibilitychange', onVisibilityChange)
    runLoop()

    if (window.addDisposable) {
        addDisposable(() => {
            disposed = true
            clearScheduledTick()
            document.removeEventListener('visibilitychange', onVisibilityChange)
            if (visibilityObserver) {
                visibilityObserver.disconnect()
            }
            entriesByElement.clear()
        })
    }
}

function initGlobalSplitLines(scope = document) {
    const elements = scope.querySelectorAll(SPLIT_LINES_SELECTOR)
    if (!elements.length) return

    elements.forEach(element => {
        if (element.dataset.splitLinesBound === '1') return

        const linesClassAttr = element.getAttribute('data-split-lines-class')
        const linesClass = linesClassAttr && linesClassAttr.trim()
            ? linesClassAttr.trim()
            : 'text-line'
        const maskAttr = element.getAttribute('data-split-mask')
        const mask = maskAttr && maskAttr.trim()
            ? maskAttr.trim()
            : 'lines'

        new SplitText(element, {
            type: 'lines',
            mask,
            linesClass,
        })

        element.dataset.splitLinesBound = '1'
    })
}

function initSplitLinesScrollAnimations(scope = document) {
    const elements = scope.querySelectorAll('[data-split-lines-scroll]')
    if (!elements.length) return

    const parseScrubValue = rawValue => {
        if (rawValue === null || rawValue === undefined || rawValue === '') return 1
        const value = String(rawValue).trim().toLowerCase()
        if (!value) return 1
        if (value === 'true') return true
        if (value === 'false') return false
        const numeric = Number(value)
        return Number.isFinite(numeric) ? numeric : 1
    }

    elements.forEach(element => {
        if (element.dataset.splitLinesScrollBound === '1') return

        const lines = element.querySelectorAll('.text-mask-line-mask .text-line')
        if (!lines.length) return
        const lineMasks = element.querySelectorAll('.text-mask-line-mask')
        const perLineMode =
            element.hasAttribute('data-split-lines-scroll-per-line') ||
            (element.getAttribute('data-split-lines-scroll-mode') || '').trim().toLowerCase() === 'line'

        element.dataset.splitLinesScrollBound = '1'

        const blur = Number(element.getAttribute('data-split-lines-scroll-blur') || 8)
        const staggerEach = Number(element.getAttribute('data-split-lines-scroll-stagger') || 0.85)
        const start = element.getAttribute('data-split-lines-scroll-start') || (windowWidth >= 1280 ? 'top 78%' : 'top 90%')
        const end = element.getAttribute('data-split-lines-scroll-end') || `+=${Math.max(40, lines.length * 22)}%`
        const scrub = parseScrubValue(element.getAttribute('data-split-lines-scroll-scrub'))
        const perLineEnd = element.getAttribute('data-split-lines-scroll-line-end') || '+=35%'
        const timelines = []

        gsap.set(lines, {
            autoAlpha: 0,
            filter: `blur(${blur}px)`
        })

        lineMasks.forEach(maskItem => {
            maskItem.style.overflow = 'visible'
        })

        if (perLineMode) {
            lines.forEach((line, index) => {
                const triggerLine = lineMasks[index] || line
                const timeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: triggerLine,
                        start,
                        end: perLineEnd,
                        scrub,
                        invalidateOnRefresh: true,
                    }
                })

                timeline.to(line, {
                    autoAlpha: 1,
                    filter: 'blur(0px)',
                    ease: 'none',
                    overwrite: true
                })

                timelines.push(timeline)
            })
        } else {
            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start,
                    end,
                    scrub,
                    invalidateOnRefresh: true,
                }
            })

            timeline.to(lines, {
                autoAlpha: 1,
                filter: 'blur(0px)',
                stagger: {
                    each: staggerEach
                },
                ease: 'none',
                overwrite: true
            })

            timelines.push(timeline)
        }

        if (window.addDisposable) {
            addDisposable(() => {
                timelines.forEach(timeline => {
                    timeline.scrollTrigger?.kill()
                    timeline.kill()
                })
            })
        }
    })
}

function runPageEnterAnimation() {
    if (shouldSkipPageEnterLock()) {
        if (!pendingApplyFormHashScroll) {
            hidePreloader()
        }
        return
    }

    const homeTitle = new SplitText('[data-home-heading]', {
        type: "lines, words, chars",
        mask: windowWidth >= 1280 ? "lines" : "chars",
        linesClass: "text-line",
    })

    const tl = gsap.timeline()
    tl.to('.preloader > div', {delay:.1,y:-10,autoAlpha:0,scale:.9,stagger:.1}, '<')
    tl.fromTo('.preloader', {autoAlpha:1},{
        autoAlpha: 0,
        duration: 0.5,
        ease: "power1.inOut"
    }, '<+=.5')

    if(windowWidth >= 1280) {
        tl.set(homeTitle.chars, {
            y: 40,
            autoAlpha:0,
            filter: 'blur(5px)'
        }, '<')
    }else {
        tl.set(homeTitle.lines, {
            scale: .9,
            y: 50,
            autoAlpha:0,
        }, '<')
    }

    if(windowWidth >= 1280) {
        tl.to(homeTitle.chars, {
            y: 0,
            autoAlpha: 1,
            filter: 'blur(0px)',
            duration: 1.5,
            ease: "expo.out",
            stagger: 0.02
        }, '<+.1')
    }else {
        tl.to(homeTitle.lines, {
            scale: 1,
            y: 0,
            autoAlpha: 1,
            duration: 2,
            ease: "expo.out",
            stagger: 0.1,
        }, '<+=.25')
        
        tl.from('.descr_cta_course', {
            autoAlpha:0,
            y:10,
            duration: 1.2,
            stagger:.1,
            ease: "expo.out"
        }, '<+=.5')
        tl.from('#free_lesson_cta', {
            autoAlpha:0,
            y:10,
            duration: 1.2,
            ease: "expo.out"
        }, '<+=.2')
    }

    tl.from('.header_top', {
        autoAlpha:0,
        duration: 1.2,
        filter: windowWidth >= 1280 ? 'blur(10px)' : 'none',
        stagger:.1,
        ease: "expo.out",
        onComplete() {
            isPreloaderHidden = true
        }
    }, '<')

    const tl2 = gsap.timeline()
    tl2.from('[data-hone-course-ini]', {
        delay:1,
        autoAlpha:0,
        y:5,
        duration: 1.2,
        stagger:.1,
        ease: "expo.out"
    })
}

function shouldSkipPageEnterLock() {
    return pendingApplyFormHashScroll || hasEarlyScrollIntent || getCurrentScrollPosition() > 4
}

function hidePreloader() {
    if (isPreloaderHidden) return

    isPreloaderHidden = true

    gsap.killTweensOf('.preloader')
    gsap.killTweensOf('.preloader > div')

    gsap.to('.preloader > div', {
        y: -10,
        autoAlpha: 0,
        scale: 0.9,
        stagger: 0.08,
        duration: 0.24,
        overwrite: true,
    })

    gsap.to('.preloader', {
        autoAlpha: 0,
        duration: 0.28,
        ease: 'power1.out',
        overwrite: true,
        onComplete() {
            gsap.set('.preloader', { display: 'none' })
        }
    })
}

function releaseApplyFormPendingState() {
    document.documentElement.classList.remove('apply-form-pending')
}

function initSmoothScroll() {
    const mobileMainScroller =
        windowWidth < 1280
            ? document.querySelector('.main')
            : null

    scroll = new Lenis({
        lerp: .2,
        duration: .8,
        ...(mobileMainScroller ? {
            wrapper: mobileMainScroller,
            content: mobileMainScroller,
        } : {})
    })
    window.NBSLenis = scroll

	scroll.on('scroll', ScrollTrigger.update)

	gsap.ticker.add((time)=>{
		scroll.raf(time * 1000)
	})

	gsap.ticker.lagSmoothing(0)

	ScrollTrigger.refresh()
}

function initCheckWindowHeight() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

function initBasicFunctions() {
    const imgs = document.querySelectorAll('img[loading="lazy"]')
    imgs.forEach(img => {
        img.loading = 'eager'
        img.removeAttribute('loading')

        if (!img.complete) {
            const src = img.currentSrc || img.src
            if (src) {
                img.src = ''
                img.src = src
            }
        }

        img.decode?.().catch(() => {})
    })
}

function initVideoAuthorsSection() {
    const video_authors = document.getElementById('video_authors')
    if(!video_authors) return
    const isMobileVideoAuthorsViewport = window.innerWidth < 1279

    const videoCourseWrapper = video_authors.querySelector(CURSOR_FOLLOW_WRAPPER_SELECTOR) || video_authors.querySelector('.wrapper_video_cours')
    const videoCourseCursor = video_authors.querySelector(CURSOR_FOLLOW_ICON_SELECTOR) || video_authors.querySelector('.icon_play_video')
    const videoCourseElement = videoCourseWrapper ? videoCourseWrapper.querySelector('video') : null
    const videoCourseText = video_authors.querySelector('.text_course_video')
    let videoCourseWrapperShapeScrollTrigger = null
    let courseVideoTextScrollTrigger = null

    const isCourseVideoPlaying = () => Boolean(videoCourseElement && !videoCourseElement.paused && !videoCourseElement.ended)
    const setCourseVideoTextVisibility = (shouldShow, immediate = false) => {
        if (!videoCourseText) return
        gsap.to(videoCourseText, {
            autoAlpha: shouldShow ? 1 : 0,
            filter: shouldShow ? 'blur(0px)' : 'blur(3px)',
            duration: immediate ? 0 : 0.35,
            ease: 'power2.out',
            overwrite: true,
        })
    }
    const syncCourseVideoTextState = (immediate = false) => {
        const shouldShowByScroll = courseVideoTextScrollTrigger ? courseVideoTextScrollTrigger.isActive : false
        const shouldShow = !isCourseVideoPlaying() && shouldShowByScroll
        setCourseVideoTextVisibility(shouldShow, immediate)
    }

    const pauseCourseVideo = () => {
        if (!videoCourseElement) return
        try {
            videoCourseElement.pause()
        } catch (err) {}
    }

    const enableCourseVideoAudio = () => {
        if (!videoCourseElement) return
        videoCourseElement.removeAttribute('muted')
        videoCourseElement.defaultMuted = false
        videoCourseElement.muted = false
        videoCourseElement.volume = 1
    }

    if (videoCourseWrapper && videoCourseCursor) {
        const scaleTimelineStart = isMobileVideoAuthorsViewport ? 'top bottom' : 'top top+=100%'
        const scaleTimelineEnd = isMobileVideoAuthorsViewport ? 'top top+=40%' : '+=100%'
        gsap.timeline({
            scrollTrigger: {
                trigger: video_authors,
                scrub: true,
                start: scaleTimelineStart,
                end: scaleTimelineEnd,
            }
        })
        .to(videoCourseWrapper, {
            scale: 1.01,
            ease: 'none',
        })
    }

    if (videoCourseWrapper) {
        const shapeTimelineStart = isMobileVideoAuthorsViewport ? 'top center+=28%' : 'top top+=20%'
        const shapeTimelineEnd = isMobileVideoAuthorsViewport ? 'top top+=40%' : '+=20%'
        const videoCourseWrapperShapeTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: video_authors,
                scrub: true,
                start: shapeTimelineStart,
                end: shapeTimelineEnd,
            }
        })
        .to(videoCourseWrapper, {
            borderColor: 'transparent',
            borderRadius: 0,
            ease: 'none',
        }, '<')

        videoCourseWrapperShapeScrollTrigger = videoCourseWrapperShapeTimeline.scrollTrigger || null
    }

    if (videoCourseCursor) {
        const baseScale = 1.4
        const clickScale = 1.9
        let isPointerPressed = false
        let isCourseVideoLoading = false
        const courseVideoLoader = videoCourseCursor.querySelector('[data-course-video-cursor-loader]')

        const setCourseVideoCursorLoading = isLoading => {
            const nextLoading = Boolean(isLoading)
            if (nextLoading === isCourseVideoLoading) return
            isCourseVideoLoading = nextLoading

            if (courseVideoLoader) {
                courseVideoLoader.classList.toggle('opacity-0', !nextLoading)
            }
            videoCourseCursor.setAttribute('data-video-loading', nextLoading ? 'true' : 'false')
        }

        const setVideoWrapperPlayingClass = isPlaying => {
            video_authors.classList.toggle('is-video-playing', Boolean(isPlaying))
        }

        gsap.set(videoCourseCursor, { scale: baseScale })

        const scaleInWatchCursor = () => {
            gsap.to(videoCourseCursor, {
                scale: clickScale,
                duration: 0.2,
                ease: 'power2.out',
                overwrite: true
            })
        }

        const scaleOutWatchCursor = () => {
            gsap.to(videoCourseCursor, {
                scale: baseScale,
                duration: 0.28,
                ease: 'power2.out',
                overwrite: true
            })
        }

        const onPointerDownWatchCursor = () => {
            if (isMobileVideoAuthorsViewport) return
            isPointerPressed = true
            scaleInWatchCursor()
        }

        const onPointerUpWatchCursor = () => {
            if (isMobileVideoAuthorsViewport) return
            if (!isPointerPressed) return
            isPointerPressed = false
            scaleOutWatchCursor()
        }

        const onPointerLeaveWatchCursor = () => {
            if (isMobileVideoAuthorsViewport) return
            if (!isPointerPressed) {
                scaleOutWatchCursor()
            }
        }

        const onCourseVideoPlay = () => {
            videoCourseElement.dataset.videoStatus = 'loaded'
            syncCourseVideoTextState(true)
        }

        const onCourseVideoPause = () => {
            // Keep the video layer visible after first play so poster does not reappear.
            videoCourseElement.dataset.videoStatus = 'loaded'
            setCourseVideoCursorLoading(false)
            syncCourseVideoTextState()
            setVideoWrapperPlayingClass(false)
        }

        const onCourseVideoLoadStart = () => {
            setCourseVideoCursorLoading(true)
        }

        const onCourseVideoWaiting = () => {
            setCourseVideoCursorLoading(true)
        }

        const onCourseVideoCanPlay = () => {
            setCourseVideoCursorLoading(false)
        }

        const onCourseVideoPlaying = () => {
            setCourseVideoCursorLoading(false)
            setVideoWrapperPlayingClass(true)
        }

        const onCourseVideoError = () => {
            setCourseVideoCursorLoading(false)
        }

        syncCourseVideoTextState(true)
        setVideoWrapperPlayingClass(isCourseVideoPlaying())

        const toggleCourseVideoPlayback = event => {
            if (event) {
                event.preventDefault()
            }

            if (!videoCourseElement) return

            if (!videoCourseElement.getAttribute('src')) {
                const source = (videoCourseElement.dataset.videoSrc || '').trim()
                if (source) {
                    videoCourseElement.setAttribute('src', source)
                    try {
                        videoCourseElement.load()
                    } catch (err) {}
                }
            }
            videoCourseElement.dataset.videoStatus = 'loaded'

            const shouldPlay = videoCourseElement.paused || videoCourseElement.ended
            if (shouldPlay) {
                setCourseVideoTextVisibility(false, true)
                setCourseVideoCursorLoading(true)
                enableCourseVideoAudio()
                const playPromise = videoCourseElement.play()
                if (playPromise && typeof playPromise.catch === 'function') {
                    playPromise.catch(() => {
                        setCourseVideoCursorLoading(false)
                        syncCourseVideoTextState()
                    })
                }

                if (scroll && typeof scroll.scrollTo === 'function') {
                    const currentY = getCurrentScrollPosition()
                    const shapeEnd = Number(videoCourseWrapperShapeScrollTrigger?.end)
                    const isMobileViewport = window.innerWidth < 1279
                    if (isMobileViewport) return
                    let targetY = null

                    if (Number.isFinite(shapeEnd)) {
                        targetY = Math.max(0, shapeEnd + 8)
                    } else {
                        const rect = video_authors.getBoundingClientRect()
                        targetY = Math.max(0, currentY + rect.top - (window.innerHeight * 0.12))
                    }

                    if (Number.isFinite(targetY) && Math.abs(currentY - targetY) > 6) {
                        scroll.scrollTo(targetY, {
                            duration: 0.65,
                            lock: false,
                            force: false,
                        })
                    }
                }
                return
            }

            pauseCourseVideo()
        }

        const onCourseVideoCursorClick = event => {
            event.preventDefault()
            event.stopPropagation()
            toggleCourseVideoPlayback()
        }

        const onCourseVideoWrapperClick = event => {
            toggleCourseVideoPlayback(event)
        }

        videoCourseCursor.addEventListener('pointerdown', onPointerDownWatchCursor)
        videoCourseCursor.addEventListener('pointerleave', onPointerLeaveWatchCursor)
        videoCourseCursor.addEventListener('click', onCourseVideoCursorClick)
        if (videoCourseWrapper) {
            videoCourseWrapper.addEventListener('click', onCourseVideoWrapperClick)
        }
        if (videoCourseElement) {
            videoCourseElement.addEventListener('play', onCourseVideoPlay)
            videoCourseElement.addEventListener('pause', onCourseVideoPause)
            videoCourseElement.addEventListener('ended', onCourseVideoPause)
            videoCourseElement.addEventListener('loadstart', onCourseVideoLoadStart)
            videoCourseElement.addEventListener('waiting', onCourseVideoWaiting)
            videoCourseElement.addEventListener('canplay', onCourseVideoCanPlay)
            videoCourseElement.addEventListener('playing', onCourseVideoPlaying)
            videoCourseElement.addEventListener('error', onCourseVideoError)
        }
        window.addEventListener('pointerup', onPointerUpWatchCursor)
        window.addEventListener('pointercancel', onPointerUpWatchCursor)
        if (videoCourseWrapper) {
            videoCourseWrapper.addEventListener('pointerdown', onPointerDownWatchCursor)
            videoCourseWrapper.addEventListener('pointerleave', onPointerLeaveWatchCursor)
        }
        if (window.addDisposable) {
            addDisposable(() => {
                videoCourseCursor.removeEventListener('pointerdown', onPointerDownWatchCursor)
                videoCourseCursor.removeEventListener('pointerleave', onPointerLeaveWatchCursor)
                videoCourseCursor.removeEventListener('click', onCourseVideoCursorClick)
                if (videoCourseWrapper) {
                    videoCourseWrapper.removeEventListener('click', onCourseVideoWrapperClick)
                }
                if (videoCourseElement) {
                    videoCourseElement.removeEventListener('play', onCourseVideoPlay)
                    videoCourseElement.removeEventListener('pause', onCourseVideoPause)
                    videoCourseElement.removeEventListener('ended', onCourseVideoPause)
                    videoCourseElement.removeEventListener('loadstart', onCourseVideoLoadStart)
                    videoCourseElement.removeEventListener('waiting', onCourseVideoWaiting)
                    videoCourseElement.removeEventListener('canplay', onCourseVideoCanPlay)
                    videoCourseElement.removeEventListener('playing', onCourseVideoPlaying)
                    videoCourseElement.removeEventListener('error', onCourseVideoError)
                }
                window.removeEventListener('pointerup', onPointerUpWatchCursor)
                window.removeEventListener('pointercancel', onPointerUpWatchCursor)
                if (videoCourseWrapper) {
                    videoCourseWrapper.removeEventListener('pointerdown', onPointerDownWatchCursor)
                    videoCourseWrapper.removeEventListener('pointerleave', onPointerLeaveWatchCursor)
                }
                setCourseVideoCursorLoading(false)
            })
        }
    }

    if (videoCourseElement) {
        const pauseCourseVideoOutsideViewport = () => {
            if (videoCourseElement.paused) return
            pauseCourseVideo()
        }

        const courseVideoVisibilityTrigger = ScrollTrigger.create({
            trigger: video_authors,
            start: 'top bottom',
            end: 'bottom top',
            onLeave: pauseCourseVideoOutsideViewport,
            onLeaveBack: pauseCourseVideoOutsideViewport,
        })

        if (window.addDisposable) {
            addDisposable(() => {
                courseVideoVisibilityTrigger.kill()
            })
        }
    }

    courseVideoTextScrollTrigger = ScrollTrigger.create({
        trigger: video_authors,
        start: 'top top-=20%',
        end: 'bottom top',
        onToggle: () => syncCourseVideoTextState()
    });
    syncCourseVideoTextState(true)

    if (window.addDisposable) {
        addDisposable(() => {
            courseVideoTextScrollTrigger?.kill()
        })
    }

    gsap.timeline({
        scrollTrigger: {
            trigger: video_authors,
            scrub: true,
            start: `top bottom`,
        }
    })
    .to('.text_play_video', {
        rotate: isMobileVideoAuthorsViewport ? 100 : 400,
        ease: 'none',
    }, '<')

    if (!isMobileVideoAuthorsViewport) {
        gsap.timeline({
            scrollTrigger: {
                trigger: video_authors,
                scrub: true,
                start: `bottom bottom-=20%`,
                end: `+=30%`
            }
        })
        .to('.wrapper_video_cours .bg-black', {
            ease: 'none',
            autoAlpha:.8,
            // filter: 'blur(7px)',
        }, '<')
    }
}

function initAttributeParallaxAnimations() {
    if (!window.gsap || !window.ScrollTrigger) return

    const parseDataValue = rawValue => {
        if (rawValue === undefined || rawValue === null) return null
        const value = String(rawValue).trim()
        if (!value) return null

        const numeric = Number(value)
        return Number.isFinite(numeric) ? numeric : value
    }

    const parseBooleanData = rawValue => {
        if (rawValue === undefined || rawValue === null) return null
        const value = String(rawValue).trim().toLowerCase()
        if (!value) return null
        if (value === 'true' || value === '1' || value === 'yes') return true
        if (value === 'false' || value === '0' || value === 'no') return false
        return null
    }

    const parseToggleData = rawValue => {
        if (rawValue === undefined || rawValue === null) return null
        const value = String(rawValue).trim().toLowerCase()
        if (!value) return null

        if (['on', 'enable', 'enabled', 'true', '1', 'yes'].includes(value)) return true
        if (['off', 'disable', 'disabled', 'none', 'false', '0', 'no'].includes(value)) return false

        return null
    }

    const parseScrubData = rawValue => {
        if (rawValue === undefined || rawValue === null || rawValue === '') return 1
        const boolValue = parseBooleanData(rawValue)
        if (boolValue !== null) return boolValue
        const numeric = Number(rawValue)
        return Number.isFinite(numeric) ? numeric : 1
    }

    const getDataValue = (element, keys) => {
        for (let i = 0; i < keys.length; i += 1) {
            const key = keys[i]
            const value = element.dataset[key]
            if (value !== undefined && value !== null && String(value).trim() !== '') {
                return value
            }
        }
        return null
    }

    const resolveTriggerElement = (element, rawTrigger) => {
        if (!rawTrigger) return element

        const trigger = String(rawTrigger).trim()
        if (!trigger || trigger === 'self') return element

        if (trigger.startsWith('closest:')) {
            const selector = trigger.slice(8).trim()
            return (selector && element.closest(selector)) || element
        }

        return document.querySelector(trigger) || element
    }

    const parallaxElements = gsap.utils.toArray(
        '[data-parallax], [data-rotate], [data-parallax-x], [data-parallax-y], [data-parallax-rotate], [data-parallax-scale]'
    )

    if (!parallaxElements.length) return

    parallaxElements.forEach(element => {
        const mobileToggle = parseToggleData(getDataValue(element, ['parallaxMobile']))
        const desktopToggle = parseToggleData(getDataValue(element, ['parallaxDesktop']))
        const disableMobile = parseBooleanData(getDataValue(element, ['parallaxDisableMobile']))
        const disableDesktop = parseBooleanData(getDataValue(element, ['parallaxDisableDesktop']))

        if (window.innerWidth < 1279 && (mobileToggle === false || disableMobile === true)) return
        if (window.innerWidth >= 1279 && (desktopToggle === false || disableDesktop === true)) return

        const minWidth = parseDataValue(getDataValue(element, ['parallaxMinWidth']))
        const maxWidth = parseDataValue(getDataValue(element, ['parallaxMaxWidth']))
        if (Number.isFinite(minWidth) && window.innerWidth < minWidth) return
        if (Number.isFinite(maxWidth) && window.innerWidth > maxWidth) return

        const toVars = {
            ease: getDataValue(element, ['parallaxEase']) || 'none',
            overwrite: true,
        }
        const fromVars = {}

        const propertyMap = [
            { prop: 'x', to: ['parallaxX'], from: ['parallaxFromX'] },
            { prop: 'y', to: ['parallaxY'], from: ['parallaxFromY'] },
            { prop: 'xPercent', to: ['parallaxXPercent'], from: ['parallaxFromXPercent'] },
            { prop: 'yPercent', to: ['parallaxYPercent'], from: ['parallaxFromYPercent'] },
            { prop: 'rotate', to: ['parallaxRotate', 'rotate'], from: ['parallaxFromRotate'] },
            { prop: 'rotateX', to: ['parallaxRotateX'], from: ['parallaxFromRotateX'] },
            { prop: 'rotateY', to: ['parallaxRotateY'], from: ['parallaxFromRotateY'] },
            { prop: 'scale', to: ['parallaxScale'], from: ['parallaxFromScale'] },
            { prop: 'scaleX', to: ['parallaxScaleX'], from: ['parallaxFromScaleX'] },
            { prop: 'scaleY', to: ['parallaxScaleY'], from: ['parallaxFromScaleY'] },
            { prop: 'opacity', to: ['parallaxOpacity'], from: ['parallaxFromOpacity'] },
            { prop: 'autoAlpha', to: ['parallaxAutoAlpha'], from: ['parallaxFromAutoAlpha'] },
        ]

        let hasToAnimation = false
        let hasFromAnimation = false

        propertyMap.forEach(config => {
            const toRaw = getDataValue(element, config.to)
            const fromRaw = getDataValue(element, config.from)

            const toValue = parseDataValue(toRaw)
            const fromValue = parseDataValue(fromRaw)

            if (toValue !== null) {
                toVars[config.prop] = toValue
                hasToAnimation = true
            }

            if (fromValue !== null) {
                fromVars[config.prop] = fromValue
                hasFromAnimation = true
            }
        })

        if (!hasToAnimation) return

        const transformOrigin = getDataValue(element, ['parallaxOrigin'])
        const force3D = parseBooleanData(getDataValue(element, ['parallaxForce3d']))
        const willChange = parseBooleanData(getDataValue(element, ['parallaxWillChange']))

        if (transformOrigin) {
            gsap.set(element, { transformOrigin })
        }

        if (force3D !== null) {
            gsap.set(element, { force3D })
        }

        if (willChange !== false) {
            gsap.set(element, { willChange: 'transform' })
        }

        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: resolveTriggerElement(element, getDataValue(element, ['parallaxTrigger'])),
                scrub: parseScrubData(getDataValue(element, ['parallaxScrub'])),
                start: getDataValue(element, ['parallaxStart']) || 'top bottom',
                end: getDataValue(element, ['parallaxEnd']) || '+=150%',
                invalidateOnRefresh: parseBooleanData(getDataValue(element, ['parallaxInvalidateOnRefresh'])) !== false,
                markers: parseBooleanData(getDataValue(element, ['parallaxMarkers'])) === true,
            },
        })

        if (hasFromAnimation) {
            timeline.fromTo(element, fromVars, toVars, 0)
        } else {
            timeline.to(element, toVars, 0)
        }

        if (window.addDisposable) {
            addDisposable(() => {
                timeline.scrollTrigger?.kill()
                timeline.kill()
            })
        }
    })
}

function scrollTriggerAnimations() {
    if(windowWidth < 1280) {
        if(mainWrapper) {
            ScrollTrigger.defaults({ scroller: mainWrapper })
        }else {
            document.documentElement.classList.add('jorel')
            document.querySelector('body').classList.add('jorel')
            mainWrapper?.classList.add('jorel')
        }
    }

    initSplitLinesScrollAnimations()

    const topFirstSection = document.getElementById('top-first-section')
    if(topFirstSection) {
        if(windowWidth >= 1280) {
            gsap.set(topFirstSection, {height: windowHeight * 3})
            const stickySection = topFirstSection.querySelector('.top-sticky-section')
            const topFirstSectionRect = topFirstSection.getBoundingClientRect()
            const topStickySection = stickySection.getBoundingClientRect()

            gsap.set('.top-decor-1', {rotate:45,scale:.3,autoAlpha:0,transformOrigin:'center'})
            gsap.set('.top-decor-3', {rotate:-45,scale:.3,autoAlpha:0,transformOrigin:'center'})
            gsap.set('.top-decor-2', {scaleY:0,scaleX:.9,rotate:-2,transformOrigin:'center top'})

            const tlTopDecor = gsap.timeline({ paused: true })

            tlTopDecor
            .to('.top-decor-1', {
                scale:1,
                rotate:0,
                autoAlpha:1,
                duration: .3,
                ease: 'none'
            }, '<')
            .to('.top-decor-3', {
                scale:1,
                rotate:0,
                autoAlpha:1,
                duration: .3,
                ease: 'none'
            }, '<')
            .to('.top-decor-2', {
                scaleY:1,
                scaleX:1,
                y:0,
                rotate:0,
                autoAlpha: 1,
                duration: .3,
                ease: 'none'
            }, '<+=.2')


            ScrollTrigger.create({
                trigger: topFirstSection,
                start: 'top top-=10%',

                onEnter() {
                    tlTopDecor.timeScale(1).play()
                },
                onEnterBack() {
                    tlTopDecor.timeScale(1).play()
                },
                onLeave() {
                    tlTopDecor.timeScale(2.5).reverse()
                },
                onLeaveBack() {
                    tlTopDecor.timeScale(2.5).reverse()
                },
            })


            gsap.timeline({
                scrollTrigger: {
                    trigger: topFirstSection,
                    scrub: true,
                    start: 'top top',
                    end: () => '+=' + (topFirstSectionRect.height - topStickySection.height),
                }
            })
            .to('.wrapper_heading_top', {
                y: '-5vw',
                scaleY:.9,
                ease: 'none',
            }, '<')
            .to('.wrappr_texts_top', {
                y: '-15vw',
                ease: 'none',
            }, '<')
            .to('.phone-girl-top', {
                y: 0,
                ease: 'none',
            }, '<')
            .to('.top-girl-background :is(.video_wrapper,.backdrop_video)', {
                autoAlpha: 0,
                scale: 1,
                ease: 'none',
            }, '<')
            .to('.top-text-1', {
                x: 0,
                ease: 'none',
            }, '<')
            .to('.top-text-2', {
                x: 0,
                scale: 0.8,
                transformOrigin: 'bottom left',
                ease: 'none',
            }, '<')


            gsap.timeline({
                scrollTrigger: {
                    trigger: topFirstSection,
                    scrub: true,
                    start: 'bottom bottom',
                    end:'+=70%'
                }
            })
            .to('.big-top-title', {
                y:'10vw',
                autoAlpha:0,
                filter: 'blur(30px)',
                ease: 'none',
            }, '<')
            gsap.timeline({
                scrollTrigger: {
                    trigger: topFirstSection,
                    scrub: true,
                    start: 'top top',
                    end: () => '+=' + (topFirstSectionRect.height),
                }
            })
            .to('.item-decor-top svg', {
                rotate: 45,
                ease: 'none',
            }, '<')
        }else {
            const text_mobile_descr = document.querySelector('.text_mobile_descr')
            const text_mobile_descrRect = text_mobile_descr.getBoundingClientRect()
            gsap.set(topFirstSection, {height: windowHeight + text_mobile_descrRect.height})

            const stickySection = topFirstSection.querySelector('.top-sticky-section')
            const topFirstSectionRect = topFirstSection.getBoundingClientRect()
            const topStickySection = stickySection.getBoundingClientRect()

            gsap.set('.top-decor-1', {rotate:45,scale:.3,autoAlpha:0,transformOrigin:'center'})
            gsap.set('.top-decor-3', {rotate:-45,scale:.3,autoAlpha:0,transformOrigin:'center'})
            gsap.set('.top-decor-2', {scaleY:0,scaleX:.9,rotate:-2,transformOrigin:'center top'})

            const tlTopDecor = gsap.timeline({ paused: true })

            tlTopDecor
            .to('.top-decor-1', {
                scale:1,
                rotate:0,
                autoAlpha:1,
                duration: .3,
                ease: 'none'
            }, '<')
            .to('.top-decor-3', {
                scale:1,
                rotate:0,
                autoAlpha:1,
                duration: .3,
                ease: 'none'
            }, '<')
            .to('.top-decor-2', {
                scaleY:1,
                scaleX:1,
                y:0,
                rotate:0,
                autoAlpha: 1,
                duration: .3,
                ease: 'none'
            }, '<+=.2')


            ScrollTrigger.create({
                trigger: topFirstSection,
                start: 'top top-=10%',

                onEnter() {
                    tlTopDecor.timeScale(1).play()
                },
                onEnterBack() {
                    tlTopDecor.timeScale(1).play()
                },
                onLeave() {
                    tlTopDecor.timeScale(2.5).reverse()
                },
                onLeaveBack() {
                    tlTopDecor.timeScale(2.5).reverse()
                },
            })


            gsap.timeline({
                scrollTrigger: {
                    trigger: topFirstSection,
                    scrub: true,
                    start: 'top top',
                    end: () => '+=' + (topFirstSectionRect.height - topStickySection.height),
                }
            })
            .to('.top-girl-background :is(.video_wrapper,.backdrop_video)', {
                autoAlpha: 0,
                scale: 1,
                ease: 'none',
            }, '<')
            .from('.mobile_top_video', {
                y: 109,
                scale:.9,
                ease: 'none',
            }, '<')
            .from('.mobile_top_descr', {
                y: -109,
                ease: 'none',
            }, '<')
        }
    }

    const secondSection = document.getElementById('second_section')
    const youSectionChild = document.getElementById('you-section-child')
    if(secondSection && windowWidth >= 1280) {
        gsap.timeline({
            scrollTrigger: {
                trigger: secondSection,
                scrub: true,
                start: `top top`,
                end: `+=120%`,
            }
        })
        .to('.headings_you', {
            y: '-10vw',
            scale: .9,
            autoAlpha:0,
            ease: 'none',
        }, '<')
        .to('.big-stars-you', {
            top: '40vw',
            ease: 'none',
        }, '<')
        .to('.video-you', {
            y: 0,
            scale:1,
            ease: 'none',
        }, '<')

        const card_you_1 = document.querySelector('.card_you_1')
        if(card_you_1) {
            card_you_1.addEventListener('mouseover', () => {
                gsap.to('.star_decor', {rotate:90,scale:1.3,y:'-1vw',x:'1vw',ease:'power2'})
                gsap.to('.line_decor_1', {scale:1,rotate:-30,y:'0.5vw',transformOrigin:'bottom left',ease:'power2'})
            })
            card_you_1.addEventListener('mouseleave', () => {
                gsap.to('.star_decor', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                gsap.to('.line_decor_1', {scale:1,rotate:0,y:0,x:0,ease:'power2'})
            })
        }

        const card_you_2 = document.querySelector('.card_you_2')
        if(card_you_2) {
            card_you_2.addEventListener('mouseover', () => {
                gsap.to('.decor_lines_four', {scale:.9,ease:'power2'})

                gsap.to('.decor_weather_1 path', {scale:1.14,rotate:10,transformOrigin:'center bottom',ease:'power2'})
                gsap.to('.decor_weather_2 path', {scale:1.14,rotate:-5,transformOrigin:'center bottom',ease:'power2'})
                // gsap.to('.decor_weather_1 path:nth-child(2)', {x:'0vw',rotate:180,transformOrigin:'center',ease:'power2'})
                // gsap.to('.decor_weather_1 path:nth-child(3)', {x:'0.5vw',rotate:180,transformOrigin:'center',ease:'power2'})
                // gsap.to('.decor_weather_1 path:nth-child(4)', {transformOrigin:'center',ease:'power2'})

                // gsap.to('.decor_weather_2 path:nth-child(1)', {rotate:-360,duration:1,transformOrigin:'center',ease:'power2'})
                // gsap.to('.decor_weather_2 path:nth-child(2)', {rotate:-360,duration:1,transformOrigin:'center',ease:'power2'})
                // gsap.to('.decor_weather_2 path:nth-child(3)', {rotate:-360,duration:1,transformOrigin:'center',ease:'power2'})
                // gsap.to('.decor_weather_2 path:nth-child(4)', {scale:1,transformOrigin:'center',ease:'power2'})
            })
            card_you_2.addEventListener('mouseleave', () => {
                gsap.to('.decor_lines_four', {rotate:0,scale:1,y:0,x:0,ease:'power2'})

                gsap.to('.decor_weather_1 path', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                gsap.to('.decor_weather_2 path', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                // gsap.to('.decor_weather_1 path:nth-child(2)', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                // gsap.to('.decor_weather_1 path:nth-child(3)', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                // gsap.to('.decor_weather_1 path:nth-child(4)', {rotate:0,scale:1,y:0,x:0,ease:'power2'})

                // gsap.to('.decor_weather_2 path:nth-child(1)', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                // gsap.to('.decor_weather_2 path:nth-child(2)', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                // gsap.to('.decor_weather_2 path:nth-child(3)', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                // gsap.to('.decor_weather_2 path:nth-child(4)', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
            })
        }

        const card_you_3 = document.querySelector('.card_you_3')
        if(card_you_3) {
            card_you_3.addEventListener('mouseover', () => {
                gsap.to('.heart_1', {rotate:-35,scale:1.2,x:'-2vw',y:'-1vw',ease:'power2'})
                gsap.to('.heart_2', {rotate:10,scale:1.2,y:'-4vw',x:'1vw',ease:'power2'})

                gsap.to('.lines_decor_1 path', {scale:.8,transformOrigin:'center bottom',ease:'power2'})
                gsap.to('.lines_decor_2 path', {scale:1.2,transformOrigin:'left bottom',ease:'power2'})
            })
            card_you_3.addEventListener('mouseleave', () => {
                gsap.to('.heart_1', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                gsap.to('.heart_2', {rotate:0,scale:1,y:0,x:0,ease:'power2'})

                gsap.to('.lines_decor_1 path', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                gsap.to('.lines_decor_2 path', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
            })
        }

        const card_you_4 = document.querySelector('.card_you_4')
        if(card_you_4) {
            card_you_4.addEventListener('mouseover', () => {
                gsap.to('.lines_decor_th_1', {rotate:-10,transformOrigin:'center bottom',ease:'power2'})
                gsap.to('.lines_decor_th_1 path', {scale:.9,transformOrigin:'center bottom',ease:'power2'})
                gsap.to('.lines_decor_th_2 path', {scale:1.1,rotate:10,transformOrigin:'center bottom',ease:'power2'})
            })
            card_you_4.addEventListener('mouseleave', () => {
                gsap.to('.lines_decor_th_1', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                gsap.to('.lines_decor_th_1 path', {rotate:0,scale:1,y:0,x:0,ease:'power2'})
                gsap.to('.lines_decor_th_2 path', {scaleY:1,rotate:0,y:0,x:0,ease:'power2'})
            })
        }
    }

    const streaming = document.getElementById('streaming')
    if(streaming) {
        if (windowWidth >= 1280) {
            gsap.timeline({
                scrollTrigger: {
                    trigger: streaming,
                    scrub: 1,
                    start: `top top+=100%`,
                    end: `+=200%`,
                }
            })
            .to('.first_step_decor_1', {
                scale: 1.2,
                rotate:10,
                ease: 'none',
            }, '<')
            .from('.first_step_decor_2', {
                rotate:20,
                scale:1.1,
                ease: 'none',
            }, '<')

            const decorStep2Children = gsap.utils.toArray('.decor_step_2 > img, .decor_step_2 > svg')
            const decorStep3Children = gsap.utils.toArray('.decor_step_3 > svg')
            decorStep2Children.forEach(el => { el._rndRotate = gsap.utils.random(-40, 40, 30) })
            decorStep3Children.forEach(el => { el._rndRotate = gsap.utils.random(40, 80, 40) })

            gsap.timeline({
                scrollTrigger: {
                    trigger: streaming,
                    scrub: 2,
                    start: 'top+=25% top',
                    end: '+=200%',
                }
            })
            .to(decorStep2Children, {rotate: (i, target) => target._rndRotate,scale:1.1,ease: 'none'}, '<')

            gsap.timeline({
                scrollTrigger: {
                    trigger: streaming,
                    scrub: 2,
                    start: 'top+=50% top',
                    end: '+=200%',
                }
            })
            .to(decorStep3Children, {rotate: (i, target) => target._rndRotate,scale:1.1,ease: 'none'}, '<')

            const stepGroups = [
                streaming.querySelectorAll('.decor_step_1'),
                streaming.querySelectorAll('.decor_step_2'),
                streaming.querySelectorAll('.decor_step_3'),
            ]

            stepGroups.forEach(group => {
                gsap.set(group, {
                    autoAlpha: 0,
                    scale: (i, target) => target.getAttribute('data-scale') || 0,
                    y: (i, target) => target.getAttribute('data-y') || 0,
                    x: (i, target) => target.getAttribute('data-x') || 0,
                })
            })

            const stepButtons = streaming.querySelectorAll('.item_stram_g')
            const activeStreaming = streaming.querySelector('.active_streaming')
            const initialBodyBg = '#FF0381'
            gsap.set(streaming, { height: windowHeight * 5 })

            function showStep(index) {
                stepGroups.forEach((group, i) => {
                    const isActive = i === index

                    gsap.to(group, {
                        autoAlpha: isActive ? 1 : 0,
                        scale: (j, target) => isActive ? 1 : (target.getAttribute('data-scale') || .3),
                        x: (j, target) => isActive ? 0 : (target.getAttribute('data-x') || 0),
                        y: (j, target) => {
                            const baseY = isActive ? 0 : (target.getAttribute('data-y') || 0)
                            return isActive ? baseY : baseY
                        },
                        duration: isActive ? 1 : 0.3,
                        ease: isActive ? 'bounce2' : 'power1.inOut',
                        overwrite: 'auto',
                    })
                })

                let bgColor = initialBodyBg
                if (index === 1) bgColor = '#234851'
                else if (index === 2) bgColor = '#010101'

                gsap.to(mainWrapper, {
                    backgroundColor: bgColor,
                    duration: 0.6,
                    overwrite: 'auto',
                    ease: 'power2.out',
                })
            }

            function moveActiveStreamingTo(index, immediate = false) {
                if (!activeStreaming) return

                    const targetBtn = [...stepButtons].find(btn => {
                        const btnStepIndex = (parseInt(btn.dataset.step, 10) || 1) - 1
                        return btnStepIndex === index
                    })

                if (!targetBtn) return

                    const y = targetBtn.offsetTop
                const height = targetBtn.offsetHeight

                const vars = {
                    y,
                    height,
                    overwrite: 'auto',
                    duration: immediate ? 0 : 0.25,
                }

                if (immediate) {
                    gsap.set(activeStreaming, vars)
                } else {
                    gsap.to(activeStreaming, vars)
                }
            }

            function applyStepFromScroll(index, immediateHighlight = false) {
                streaming._currentStep = index
                showStep(index)

                stepButtons.forEach(btn => {
                    const btnStepIndex = (parseInt(btn.dataset.step, 10) || 1) - 1
                    btn.classList.toggle('current', btnStepIndex === index)
                })

                moveActiveStreamingTo(index, immediateHighlight)
            }

            function scrollToStep(index) {
                const st = streaming._stepsTrigger
                if (!st) return

                const centers = [1 / 6, 0.5, 5 / 6]
                const progress = centers[index] ?? 0
                const targetY = st.start + (st.end - st.start) * progress
                scroll.scrollTo(targetY, {duration: .1, immediate: true})
            }

            streaming._currentStep = 0
            applyStepFromScroll(0, true)

            stepButtons.forEach(btn => {
                btn.addEventListener('click', () => {
                    const stepIndex = (parseInt(btn.dataset.step, 10) || 1) - 1
                    scrollToStep(stepIndex)
                })
            })

            const stepsTrigger = ScrollTrigger.create({
                trigger: streaming,
                start: 'top top',
                end: `+=${windowHeight * 4}`,
                onUpdate: (self) => {
                    const p = self.progress
                    let stepIndex

                    if (p < 1 / 3) {
                        stepIndex = 0
                    } else if (p < 2 / 3) {
                        stepIndex = 1
                    } else {
                        stepIndex = 2
                    }

                    if (stepIndex !== streaming._currentStep) {
                        applyStepFromScroll(stepIndex)
                    }
                }
            })

            ScrollTrigger.create({
                trigger: streaming,
                start: 'top top',
                end: 'bottom top',
                onToggle(self) {
                    disableBackgroundColor = self.isActive
                }
            })


            gsap.set('.legend_streaming', {autoAlpha:0,scale:.8,xPercent:100})
            ScrollTrigger.create({
                trigger: streaming,
                start: 'top top',
                end: 'bottom bottom',
                onToggle(self) {
                    gsap.to('.legend_streaming', {autoAlpha:1,scale:1,xPercent:0})
                },
                onLeave(self) {
                    gsap.to('.legend_streaming', {autoAlpha:0,scale:.8,xPercent:100})
                },
                onLeaveBack(self) {
                    gsap.to('.legend_streaming', {autoAlpha:0,scale:.8,xPercent:100})
                }
            })

            streaming._stepsTrigger = stepsTrigger

            ScrollTrigger.addEventListener('refresh', () => {
                if (!streaming || !streaming._currentStep && streaming._currentStep !== 0) return
                    moveActiveStreamingTo(streaming._currentStep, true)
            })
            ScrollTrigger.refresh()
        }else {
            if (streaming) {
                const stepGroups = [
                    streaming.querySelectorAll('.decor_step_1'),
                    streaming.querySelectorAll('.decor_step_2'),
                    streaming.querySelectorAll('.decor_step_3'),
                ]

                stepGroups.forEach(group => {
                    gsap.set(group, {
                        autoAlpha: 0,
                        scale: (i, target) => target.getAttribute('data-scale') || 0,
                        y: (i, target) => target.getAttribute('data-y') || 0,
                        x: (i, target) => target.getAttribute('data-x') || 0,
                    })
                })

                const stepButtons = Array.from(streaming.querySelectorAll('.item_stram_g'))
                const activeStreaming = streaming.querySelector('.active_streaming')
                const initialBodyBg = '#FF0381'

                const clamp = (v, a, b) => Math.max(a, Math.min(b, v))
                const lerp = (a, b, t) => a + (b - a) * t

                function showStep(index) {
                    stepGroups.forEach((group, i) => {
                        const isActive = i === index
                        gsap.to(group, {
                            autoAlpha: isActive ? 1 : 0,
                            scale: (j, target) => (isActive ? 1 : (target.getAttribute('data-scale') || 0.3)),
                            x: (j, target) => (isActive ? 0 : (target.getAttribute('data-x') || 0)),
                            y: (j, target) => (isActive ? 0 : (target.getAttribute('data-y') || 0)),
                            duration: isActive ? 1 : 0.3,
                            ease: isActive ? 'bounce2' : 'power1.inOut',
                            overwrite: 'auto',
                        })
                    })

                    let bgColor = initialBodyBg
                    if (index === 1) bgColor = '#234851'
                        else if (index === 2) bgColor = '#010101'

                            gsap.to(mainWrapper, {
                                backgroundColor: bgColor,
                                duration: 0.6,
                                overwrite: 'auto',
                                ease: 'power2.out',
                            })
                    }

                    let btnRects = []
                    let axis = 'x'

                    function measureButtons() {
                        btnRects = stepButtons.map(btn => ({
                            x: btn.offsetLeft,
                            y: btn.offsetTop,
                            w: btn.offsetWidth,
                            h: btn.offsetHeight,
                        }))

                        if (btnRects.length > 1) {
                            const y0 = btnRects[0].y
                            const sameRow = btnRects.every(r => Math.abs(r.y - y0) <= 2)
                            axis = sameRow ? 'x' : 'y'
                        } else {
                            axis = 'x'
                        }
                    }

                    function setPillToIndex(idx) {
                        if (!activeStreaming || !btnRects.length) return
                            const r = btnRects[clamp(idx, 0, btnRects.length - 1)]
                        if (axis === 'y') gsap.set(activeStreaming, { y: r.y, height: r.h })
                            else gsap.set(activeStreaming, { x: r.x, width: r.w })
                    }

                    function setPillBetween(aIdx, bIdx, t) {
                        if (!activeStreaming || btnRects.length < 2) return
                            const a = btnRects[aIdx]
                        const b = btnRects[bIdx]
                        t = clamp(t, 0, 1)
                        if (axis === 'y') {
                            gsap.set(activeStreaming, {
                                y: lerp(a.y, b.y, t),
                                height: lerp(a.h, b.h, t),
                            })
                        } else {
                            gsap.set(activeStreaming, {
                                x: lerp(a.x, b.x, t),
                                width: lerp(a.w, b.w, t),
                            })
                        }
                    }

                    function applyStepFromScroll(index) {
                        streaming._currentStep = index
                        showStep(index)
                    }

                    function setScrollArea() {
                        const vh = window.innerHeight
                        streaming.style.minHeight = `${Math.ceil(vh * 4.0)}px`
                    }

                    function scrollToStep(index) {
                        const st = streaming._stepsTrigger
                        if (!st) return

                            const step1End = 0.28
                        const step2End = 0.58

                        const pTarget = index === 0 ? 0 : (index === 1 ? step1End : step2End)
                        const targetY = st.start + (st.end - st.start) * pTarget
                        scroll.scrollTo(targetY, { duration: 0.2, immediate: true })
                    }

                    function updateActiveStreaming(p) {
                        if (!activeStreaming || btnRects.length < 2) return

                            const t1 = 0.22
                        const t2 = 0.32
                        const t3 = 0.52
                        const t4 = 0.62

                        const pts = [
                            [0.00, 0.00],
                            [t1, 0.10],
                            [t2, 1.00],
                            [t3, 1.10],
                            [t4, 2.00],
                            [1.00, 2.00],
                        ]

                        p = clamp(p, 0, 1)

                        let u = 0
                        for (let k = 0; k < pts.length - 1; k++) {
                            const a = pts[k], b = pts[k + 1]
                            if (p >= a[0] && p <= b[0]) {
                                const tt = (p - a[0]) / (b[0] - a[0] || 1)
                                u = lerp(a[1], b[1], tt)
                                break
                            }
                        }

                        const i = clamp(Math.floor(u), 0, btnRects.length - 2)
                        const tt = u - i
                        setPillBetween(i, i + 1, tt)
                    }


                    setScrollArea()
                    measureButtons()

                    streaming._currentStep = -1
                    applyStepFromScroll(0)
                    setPillToIndex(0)

                    const stepsTrigger = ScrollTrigger.create({
                        trigger: streaming,
                        start: 'top top',
                        end: () => `+=${Math.ceil(window.innerHeight * 4.8)}`,
                        // end: () => `+=${Math.ceil(window.innerHeight * 4.0)}`,
                        onUpdate: (self) => {
                            const p = self.progress

                            const pStep2 = 0.30
                            const pStep3 = 0.60

                            const stepIndex = p < pStep2 ? 0 : (p < pStep3 ? 1 : 2)
                            if (stepIndex !== streaming._currentStep) applyStepFromScroll(stepIndex)

                                updateActiveStreaming(p)
                        }
                    })

                    streaming._stepsTrigger = stepsTrigger

                stepButtons.forEach(btn => {
                    btn.addEventListener('click', (e) => {
                        e.preventDefault()

                        const st = streaming._stepsTrigger
                        if (!st) return

                        const stepIndex = (parseInt(btn.dataset.step, 10) || 1) - 1

                        const p1 = 0.00
                        const p2 = 0.32
                        const p3 = 0.62

                        const pTarget = stepIndex === 0 ? p1 : (stepIndex === 1 ? p2 : p3)

                        const targetY = st.start + (st.end - st.start) * pTarget

                        scroll.scrollTo(targetY, {
                            duration: 0.6,
                            immediate: false,
                            lock: true,
                            force: true,
                        })
                    })
                })

                    ScrollTrigger.create({
                        trigger: streaming,
                        start: 'top top',
                        end: 'bottom top',
                        onToggle(self) {
                            disableBackgroundColor = self.isActive
                        }
                    })

                    ScrollTrigger.addEventListener('refreshInit', () => {
                        setScrollArea()
                        measureButtons()
                    })

                    ScrollTrigger.addEventListener('refresh', () => {
                        setScrollArea()
                        measureButtons()
                        if (!streaming._stepsTrigger) return

                            const p = streaming._stepsTrigger.progress

                        const pStep2 = 0.30
                        const pStep3 = 0.60
                        const stepIndex = p < pStep2 ? 0 : (p < pStep3 ? 1 : 2)
                        if (stepIndex !== streaming._currentStep) applyStepFromScroll(stepIndex)

                            updateActiveStreaming(p)
                    })

                    ScrollTrigger.refresh()
                }
        }
    }

    const videoSection = document.getElementById('video-section')
    if(videoSection) {
        const rectVideoSection = videoSection.getBoundingClientRect()
        gsap.timeline({
            scrollTrigger: {
                trigger: videoSection,
                scrub: true,
                start: `top bottom`,
                end: `+=150%`,
            }
        })
            .to('.video-wrapper', {
                scale: 1,
                ease: 'none',
            })

        gsap.timeline({
            scrollTrigger: {
                trigger: videoSection,
                scrub: true,
                start: `top bottom-=70%`,
                end: `+=70%`,
            }
        })
            .to('.video-wrapper', {
                borderColor: 'transparent',
                borderRadius: 0,
                ease: 'none',
            })
        gsap.timeline({
            scrollTrigger: {
                trigger: videoSection,
                scrub: true,
                start: `top bottom-=150%`,
                end: `+=50%`,
            }
        })
            .to('.video-wrapper', {
                scale: 1.05,
                filter: 'blur(10px)',
                ease: 'none',
            }, '<')
            .to('.video-bg-scale', {
                autoAlpha: .5,
                ease: 'none',
            }, '<')
    }

    initVideoAuthorsSection()

    const blockExamples = document.getElementById('block_examples')
    if(blockExamples) {
        if(windowWidth >= 1280) {
            const horizontalExamples = document.querySelector('.horizontal_examples')
            const itemExample = blockExamples.querySelectorAll('.item_exampl')
            if(itemExample.length > 2) {
                gsap.set(blockExamples, {height:(itemExample.length - 1) * windowHeight})
                gsap.set(itemExample, {transformOrigin:'left'})

                const rectBlockExample = blockExamples.getBoundingClientRect()
                const rectHorizontalExample = horizontalExamples.getBoundingClientRect()

                const tlExamples = gsap.timeline({
                    scrollTrigger: {
                        trigger: blockExamples,
                        scrub: true,
                        start: 'top top',
                        end: `+=${rectBlockExample.height - windowHeight}`
                    }
                })
                tlExamples.to(horizontalExamples, {
                    x: -(rectHorizontalExample.width - rectHorizontalExample.left - (rectBlockExample.left * 2)),
                    ease: 'none',
                }, 0)

                console.log('work')

                gsap.timeline({
                    scrollTrigger: {
                        trigger: blockExamples,
                        scrub: true,
                        start: 'top 140%',
                        end: `+=140%`
                    }
                })
                .from('.wrapper_horiz_exmpl', {
                    yPercent: 30,
                    left: '40%',
                    scale:.9,
                    ease: 'none',
                })

                gsap.timeline({
                    scrollTrigger: {
                        trigger: blockExamples,
                        scrub: true,
                        start: 'bottom bottom+=60%',
                        end: `+=50%`
                    }
                })
                .to('.top_academy_text', {
                    autoAlpha:0,
                    x:-10,
                    ease: 'none',
                })
            }
        }else {
            const horizontalExamples = document.querySelector('.horizontal_examples')
            const itemExample = blockExamples.querySelectorAll('.item_exampl')
            if(itemExample.length > 2) {
                gsap.set(blockExamples, {height:(itemExample.length - 1) * windowHeight})
                gsap.set(itemExample, {transformOrigin:'left'})

                const rectBlockExample = blockExamples.getBoundingClientRect()
                const rectHorizontalExample = horizontalExamples.getBoundingClientRect()

                const tlExamples = gsap.timeline({
                    scrollTrigger: {
                        trigger: blockExamples,
                        scrub: true,
                        start: 'top top',
                        end: `bottom bottom`
                    }
                })
                tlExamples.to(horizontalExamples, {
                    x: -(rectHorizontalExample.width - (windowWidth - (rectHorizontalExample.left + rectBlockExample.left))),
                    ease: 'none',
                })
            }
        }
    }

    const soloWithUs = document.getElementById('solo_with_us')
    if (soloWithUs) {
        if(windowWidth >= 1280) {
            const itemsSolo = gsap.utils.toArray('.badges-wrap-1 .item_badg_g')
            const itemsSolo2 = gsap.utils.toArray('.badges-wrap-2 .item_badg_g')
            gsap.set(soloWithUs, {height:windowHeight * 7})

            const idleStyle = {
                fontSize: '3.4vw',
                backgroundColor: '#397684'
            }

            const activeStyle = {
                fontSize: '7.222222222222221vw',
                backgroundColor: '#1D5A68'
            }

            gsap.set(itemsSolo, {...idleStyle,transformOrigin:'50% 50%'})

            let currentIndex = -1

            function animateToIdle(index) {
                if (index < 0) return
                    const el = itemsSolo[index]
                gsap.killTweensOf(el)
                gsap.to(el, {
                    ...idleStyle,
                    duration: 0.4,
                    ease: 'power2.out'
                })
            }

            const st1 = ScrollTrigger.create({
                trigger: soloWithUs,
                start: 'top top',
                end: `+=300%`,
                scrub: true,
                onUpdate(self) {
                    if (!self.isActive) return

                    const index = Math.round(self.progress * (itemsSolo.length - 1))
                    if (index === currentIndex) return

                        const newEl = itemsSolo[index]
                    const oldEl = currentIndex >= 0 ? itemsSolo[currentIndex] : null

                    gsap.killTweensOf([newEl, oldEl])

                    if (oldEl) {
                        gsap.to(oldEl, {
                            ...idleStyle,
                            duration: 0.3,
                            ease: 'power2.out'
                        })
                    }

                    gsap.to(newEl, {
                        ...activeStyle,
                        duration: 0.5,
                        ease: 'osmoBounce'
                    })

                    currentIndex = index
                },
                onLeave(self) {
                    animateToIdle(currentIndex)
                    currentIndex = -1
                },
                onLeaveBack(self) {
                    animateToIdle(currentIndex)
                    currentIndex = -1
                }
            })

            let isYellow = false
            const tl2 = gsap.timeline({
                scrollTrigger: {
                    trigger: soloWithUs,
                    scrub: true,
                    start: () => st1.end,
                    end: `+=100%`,
                    onUpdate(self) {
                        if (self.progress > 0.3 && !isYellow) {
                            isYellow = true
                            gsap.to('#solo_section', {duration:0.3,overwrite:true,backgroundColor:'#C2FF0D',ease:'power1.inOut'})

                            gsap.to('.item_titl_sol:first-child', {duration:0.3,overwrite:true,color:'#666366',ease:'power1.inOut'})
                            gsap.to('.item_titl_sol:last-child', {duration:0.3,overwrite:true,color:'#FF03FF',ease:'power1.inOut'})
                        } else if (self.progress <= 0.3 && isYellow) {
                            isYellow = false
                            gsap.to('#solo_section', {duration:0.3,overwrite:true,backgroundColor:'#010101',ease:'power1.inOut'})
                            
                            gsap.to('.item_titl_sol:first-child', {duration:0.3,overwrite:true,color:'#C2FF0D',ease:'power1.inOut'})
                            gsap.to('.item_titl_sol:last-child', {duration:0.3,overwrite:true,color:'#666366',ease:'power1.inOut'})
                        }
                    }
                }
            })
            .to('.headings-with-us', {
                x: 0,
                ease: 'none',
            }, '<')
            .to('.badges-wrap-1', {
                autoAlpha:0,
                ease: 'none',
            }, '<')
            .to('.badges-wrap-1 > div', {
                x: -200,
                scale:.5,
                autoAlpha:0,
                stagger: .1,
                ease: 'none',
            }, '<')
            .from('.badges-wrap-2 > div', {
                x: 40,
                scale:.9,
                stagger: .02,
                autoAlpha:0,
                ease: 'none',
            }, '<+=.5')

            const idleStyle2 = {
                fontSize: '3.4vw',
                backgroundColor: '#FF03FF'
            }

            const activeStyle2 = {
                fontSize: '7.222222222222221vw',
                backgroundColor: '#A80FA8'
            }

            gsap.set(itemsSolo2, {...idleStyle2,transformOrigin:'50% 50%'})
            let currentIndex2 = -1

            function animateToIdle2(index) {
                if (index < 0) return
                    const el = itemsSolo2[index]
                gsap.killTweensOf(el)
                gsap.to(el, {
                    ...idleStyle2,
                    duration: 0.4,
                    ease: 'power2.out'
                })
            }

            const st2 = tl2.scrollTrigger
            ScrollTrigger.create({
                trigger: soloWithUs,
                start: 'top top-=400%',
                end: `+=250%`,
                scrub: true,
                onUpdate(self) {
                    if (!self.isActive) return

                    const index = Math.round(self.progress * (itemsSolo2.length - 1))
                    if (index === currentIndex2) return

                    const newEl = itemsSolo2[index]
                    const oldEl = currentIndex2 >= 0 ? itemsSolo2[currentIndex2] : null

                    gsap.killTweensOf([newEl, oldEl])

                    if (oldEl) {
                        gsap.to(oldEl, {
                            ...idleStyle2,
                            duration: 0.3,
                            ease: 'power2.out'
                        })
                    }

                    gsap.to(newEl, {
                        ...activeStyle2,
                        duration: 0.5,
                        ease: 'osmoBounce'
                    })

                    currentIndex2 = index
                },
                onLeave(self) {
                    animateToIdle2(currentIndex2)
                    currentIndex2 = -1
                },
                onLeaveBack(self) {
                    animateToIdle2(currentIndex2)
                    currentIndex2 = -1
                }
            })

            gsap.timeline({
                scrollTrigger: {
                    trigger: soloWithUs,
                    scrub: true,
                    start: `top top-=400%`,
                    end: `+=200%`
                }
            })
            .to(soloWithUs, {
                y: '-20vw',
                ease: 'none',
            })
        }else {
            let isYellow = false
            gsap.set(soloWithUs, {height:windowHeight * 2})

            const tl2 = gsap.timeline({
                scrollTrigger: {
                    trigger: soloWithUs,
                    scrub: true,
                    start: 'top top',
                    end: `bottom bottom`,
                    onUpdate(self) {
                        if (self.progress > 0.3 && !isYellow) {
                            isYellow = true
                            gsap.to('#solo_section', {duration:0.3,overwrite:true,backgroundColor:'#C2FF0D',ease:'power1.inOut'})

                            gsap.to('.item_titl_sol:first-child', {duration:0.3,overwrite:true,color:'#666366',ease:'power1.inOut'})
                            gsap.to('.item_titl_sol:last-child', {duration:0.3,overwrite:true,color:'#FF03FF',ease:'power1.inOut'})
                        } else if (self.progress <= 0.3 && isYellow) {
                            isYellow = false
                            gsap.to('#solo_section', {duration:0.3,overwrite:true,backgroundColor:'#010101',ease:'power1.inOut'})
                            
                            gsap.to('.item_titl_sol:first-child', {duration:0.3,overwrite:true,color:'#C2FF0D',ease:'power1.inOut'})
                            gsap.to('.item_titl_sol:last-child', {duration:0.3,overwrite:true,color:'#666366',ease:'power1.inOut'})
                        }
                    }
                }
            })
            .to('.badges-wrap-1', {
                autoAlpha:0,
                ease: 'none',
            }, '<')
            .to('.badges-wrap-1 > div', {
                x: -200,
                scale:.5,
                autoAlpha:0,
                stagger: .1,
                ease: 'none',
            }, '<')
            .from('.badges-wrap-2 > div', {
                x: 40,
                scale:.9,
                stagger: .1,
                autoAlpha:0,
                ease: 'none',
            }, '<+=.5')
        }
    }

    const reviewsLive = document.getElementById('reviews_live')
    if (reviewsLive) {
        const cards  = gsap.utils.toArray('.item_review_go')
        const titles = gsap.utils.toArray('.item_publ_g')
        if(windowWidth >= 1280) {
            gsap.set(reviewsLive, { height: cards.length * windowHeight })

            gsap.timeline({
                scrollTrigger: {
                    trigger: reviewsLive,
                    scrub: true,
                    start: 'top bottom',
                    end: 'bottom bottom',
                }
            })
            .to('.wrapper_reviews_g', {
                y: 0,
                ease: 'none',
            }, '<')

            function setCurrentTab(index) {
                titles.forEach((el, i) => {
                    el.classList.toggle('current', i === index)
                })
            }

            const stepLabels = ['tab1', 'tab2', 'tab3']
            let stepEdges = null

            const tlReviews = gsap.timeline({
                scrollTrigger: {
                    trigger: reviewsLive,
                    scrub: true,
                    start: 'top center',
                    end: 'bottom bottom',
                    onUpdate: self => {
                        if (!stepEdges) {
                            const times = stepLabels.map(label => tlReviews.labels[label])
                            const dur = tlReviews.duration()

                            stepEdges = []
                            stepEdges[0] = 0

                            for (let i = 0; i < times.length - 1; i++) {
                                stepEdges[i + 1] = (times[i] + times[i + 1]) / 2
                            }

                            stepEdges[stepLabels.length] = dur
                        }

                        const dur = self.animation.duration()
                        const tRaw = self.animation.time()
                        const t = Math.min(tRaw, dur - 0.0001)

                        let activeIndex = 0
                        for (let i = 0; i < stepEdges.length - 1; i++) {
                            if (t >= stepEdges[i] && t < stepEdges[i + 1]) {
                                activeIndex = i
                                break
                            }
                        }

                        setCurrentTab(activeIndex)
                    }
                }
            })
            tlReviews
            .from(cards[0], {
                yPercent: 100,
                rotateX: 40,
                rotate: 10,
                ease: 'none',
            })
            .addLabel('tab1')
            .to(cards[0], {
                backgroundColor: '#ECFFB4',
                ease: 'none',
            }, '>')
            .from(cards[1], {
                yPercent: 200,
                rotateX: 40,
                rotate: 10,
                ease: 'none',
            }, '>-=.63')
            .addLabel('tab2')
            .to(cards[1], {
                backgroundColor: '#ECFFB4',
                ease: 'none',
            }, '>')
            .from(cards[2], {
                yPercent: 200,
                rotateX: 40,
                rotate: 10,
                ease: 'none',
            }, '>-=.63')
            .addLabel('tab3')

            titles.forEach((title) => {
                title.addEventListener('click', () => {
                    const tabIndex1based = Number(title.dataset.isTabl)
                    const tabIndex0based = tabIndex1based - 1
                    const label = `tab${tabIndex1based}`

                    setCurrentTab(tabIndex0based)
                    scrollToLabel(tlReviews, label)
                })
            })

            function scrollToLabel(tl, label) {
                const st = tl.scrollTrigger
                if (!st) return

                    const labelTime = tl.labels[label]
                if (labelTime == null) return

                    const progress = labelTime / tl.duration()
                const scrollY = st.start + (st.end - st.start) * progress

                scroll.scrollTo(scrollY, { duration: 1.5 })
            }
        }else {
            const heading_reviews_facts = document.getElementById('heading_reviews_facts')
            const heading_reviews_factsRect = heading_reviews_facts.getBoundingClientRect()

            const sticky_reviews_live = document.getElementById('sticky_reviews_live')
            const reviewsLiveStyle = window.getComputedStyle(sticky_reviews_live)
            const topStyleValueReviews = parseInt(reviewsLiveStyle.top)


            gsap.set(reviewsLive, { height: cards.length * windowHeight })
            const tlReviews = gsap.timeline({
                scrollTrigger: {
                    trigger: reviewsLive,
                    scrub: true,
                    start: 'top center',
                    end: 'bottom bottom'
                }
            })
            tlReviews
            .from(cards[0], {
                yPercent: 100,
                rotateX: 40,
                rotate: 10,
                ease: 'none',
            })
            .to(cards[0], {
                backgroundColor: '#ECFFB4',
                ease: 'none',
            }, '>')
            .from(cards[1], {
                y: windowHeight - heading_reviews_factsRect.height - topStyleValueReviews,
                rotateX: 40,
                rotate: 10,
                ease: 'none',
            }, '>-=.63')
            .to(cards[1], {
                backgroundColor: '#ECFFB4',
                ease: 'none',
            }, '>')
            .from(cards[2], {
                y: windowHeight - heading_reviews_factsRect.height - topStyleValueReviews,
                rotateX: 40,
                rotate: 10,
                ease: 'none',
            }, '>-=.63')
        }
    }

    initAttributeParallaxAnimations()

    const sectionsWrapColor = gsap.utils.toArray('.section_color_bg[data-color]')
    if(sectionsWrapColor) {
        sectionsWrapColor.forEach(section => {
            const color = section.dataset.color
            if (!color) return

                ScrollTrigger.create({
                  trigger: section,
                  start: 'top top+=110%',
                  end: 'bottom bottom',
                  onEnter: () => {
                    if(disableBackgroundColor) return
                    gsap.to(mainWrapper, {
                      backgroundColor: color,
                      duration: 0.6,
                      ease: 'power2.out'
                  })
                },
                onEnterBack: () => {
                    if(disableBackgroundColor) return
                    gsap.to(mainWrapper, {
                      backgroundColor: color,
                      duration: 0.6,
                      ease: 'power2.out'
                  })
                }
            })
        })
    }

    const sectionsCourseColor = gsap.utils.toArray('.section_color_course[data-color]')
    if (sectionsCourseColor.length) {
        let activeCourseColor = DEFAULT_COURSE_BG_COLOR
        const courseColorTriggers = []

        const getViewportCenterY = () => {
            const customScroller =
                windowWidth < 1280
                    ? mainWrapper
                    : null
            if (customScroller) {
                const scrollerRect = customScroller.getBoundingClientRect()
                return scrollerRect.top + (customScroller.clientHeight / 2)
            }
            return window.innerHeight / 2
        }

        const applyCourseColor = (color, immediate = false) => {
            if (!color || disableBackgroundColor) return
            if (activeCourseColor === color) return

            activeCourseColor = color
            gsap.to(mainWrapper, {
                backgroundColor: color,
                duration: immediate ? 0 : 1.05,
                ease: 'power3.out',
                overwrite: 'auto'
            })
        }

        const syncCourseColorByCenter = () => {
            if (disableBackgroundColor) return

            const centerY = getViewportCenterY()
            let bestMatch = null
            let bestDistance = Infinity

            sectionsCourseColor.forEach(section => {
                const color = section.dataset.color
                if (!color) return

                const rect = section.getBoundingClientRect()
                const isInside = centerY >= rect.top && centerY <= rect.bottom
                const distance = isInside
                    ? 0
                    : Math.min(Math.abs(centerY - rect.top), Math.abs(centerY - rect.bottom))

                if (distance < bestDistance) {
                    bestDistance = distance
                    bestMatch = { section, color }
                }
            })

            if (bestMatch) {
                applyCourseColor(bestMatch.color)
            }
        }

        sectionsCourseColor.forEach((section, index) => {
            const color = section.dataset.color
            if (!color) return

            const trigger = ScrollTrigger.create({
                trigger: section,
                start: 'top center',
                end: 'bottom center',
                onEnter: () => applyCourseColor(color),
                onEnterBack: () => applyCourseColor(color),
                onRefresh: () => {
                    if (index === 0 && !activeCourseColor) {
                        applyCourseColor(color, true)
                    }
                }
            })

            courseColorTriggers.push(trigger)
        })

        const liveSyncTrigger = ScrollTrigger.create({
            trigger: sectionsCourseColor[0],
            endTrigger: sectionsCourseColor[sectionsCourseColor.length - 1],
            start: 'top bottom',
            end: 'bottom top',
            onUpdate: syncCourseColorByCenter,
            onRefresh: syncCourseColorByCenter,
            onRefreshInit: syncCourseColorByCenter
        })

        courseColorTriggers.push(liveSyncTrigger)
        requestAnimationFrame(syncCourseColorByCenter)

        if (window.addDisposable) {
            addDisposable(() => {
                courseColorTriggers.forEach(trigger => trigger.kill())
            })
        }
    }

    //Courses
    const topFirstSectionCourses = document.getElementById('top-first-section-courses')
    if(topFirstSectionCourses) {
        if(windowWidth >= 1280) {
            // gsap.set('#free_lesson_cta', {yPercent:150})

            gsap.timeline({
                scrollTrigger: {
                    trigger: topFirstSectionCourses,
                    scrub: true,
                    start: 'top top',
                    end: '+=40%'
                }
            })
            .to('.video_watch_btn', {
                y:'-5vw',
                autoAlpha: 0,
                ease: 'none',
            }, '<')
            .fromTo('.top_course_heading', {
                y:'5vw',
            },{
                y:'-7vw',
                ease: 'none',
            }, '<')
            .to('.descr_cta_course', {
                y:'-6.3vw',
                scale:1,
                autoAlpha: 1,
                ease: 'none',
            }, '<')

            gsap.timeline({
                scrollTrigger: {
                    trigger: topFirstSectionCourses,
                    scrub: true,
                    start: 'top top-=10%',
                    end: '+=30%'
                }
            })
                .to('#free_lesson_cta', {
                    y:0,
                    scale:1,
                    ease: 'none',
                })

            gsap.timeline({
                scrollTrigger: {
                    trigger: topFirstSectionCourses,
                    scrub: true,
                    start: 'top top-=80%',
                    end: '+=40%'
                }
            })
            .to('.wrapper_top_curs', {
                autoAlpha:0,
                ease: 'none',
            }, '<')


            gsap.timeline({
                scrollTrigger: {
                    trigger: topFirstSectionCourses,
                    scrub: true,
                    start: 'top top',
                    end: '+=170%'
                }
            })
            .to('.image_video_poster', {
                scale:1.1,
                ease: 'none',
            }, '<')

            gsap.timeline({
                scrollTrigger: {
                    trigger: topFirstSectionCourses,
                    scrub: true,
                    start: 'top top-=20%',
                    end: '+=150%'
                }
            })
            .to('#course_video_top', {
                filter: 'blur(10px)',
                ease: 'none',
            }, '<')
            .to('.overlap_video_cours', {
                autoAlpha:.5,
                ease: 'none',
            }, '<')

            gsap.timeline({
                scrollTrigger: {
                    trigger: topFirstSectionCourses,
                    scrub: true,
                    start: 'top top-=200%',
                    end: '+=150%'
                }
            })
            .to('#course_video_top', {
                autoAlpha:0,
                ease: 'none',
            })
        }else {
            gsap.timeline({
                scrollTrigger: {
                    trigger: topFirstSectionCourses,
                    scrub: true,
                    start: 'top top',
                    end: '+=40%'
                }
            })
            .to('.wrapper_top_curs', {
                autoAlpha:0,
                ease: 'none',
            }, '<')

            gsap.timeline({
                scrollTrigger: {
                    trigger: topFirstSectionCourses,
                    scrub: true,
                    start: 'top top',
                    end: '+=20%'
                }
            })
                .to('#free_lesson_cta a', {
                    width: '100%',
                    // y:0,
                    // scale:1,
                    ease: 'none',
                })

            // gsap.timeline({
            //     scrollTrigger: {
            //         trigger: topFirstSectionCourses,
            //         scrub: true,
            //         start: 'top top-=10%',
            //         end: '+=30%',
            //         markers: true
            //     }
            // })
            //     .to('#free_lesson_cta', {
            //         y:0,
            //         scale:1,
            //         ease: 'none',
            //     })


            gsap.timeline({
                scrollTrigger: {
                    trigger: topFirstSectionCourses,
                    scrub: true,
                    start: 'top top'
                }
            })
            .to('.image_video_poster', {
                scale:1.1,
                ease: 'none',
            }, '<')

            gsap.timeline({
                scrollTrigger: {
                    trigger: topFirstSectionCourses,
                    scrub: true,
                    start: 'top top',
                    end: '+=150%'
                }
            })
            .to('#course_video_top', {
                filter: 'blur(10px)',
                ease: 'none',
            }, '<')
            .to('.overlap_video_cours', {
                autoAlpha:.5,
                ease: 'none',
            }, '<')

            gsap.timeline({
                scrollTrigger: {
                    trigger: topFirstSectionCourses,
                    scrub: true,
                    start: 'top top-=50%',
                    end: '+=150%'
                }
            })
            .to('#course_video_top', {
                autoAlpha:0,
                ease: 'none',
            })
        }
    }
    const soundLikeYou = document.getElementById('sound_like_you')
    if(soundLikeYou) {
        if(windowWidth >= 1280) {
            gsap.timeline({
                scrollTrigger: {
                    trigger: soundLikeYou,
                    scrub: true,
                    start: 'bottom bottom-=20%',
                    end: '+=30%'
                }
            })
            .to('#heading_sound', {
                autoAlpha: 0,
                // scale:.98,
                // yPercent:-10,
                filter: 'blur(5px)',
                ease: 'none',
            }, '<')
        }
    }

    gsap.utils.toArray('[data-slide-down]').forEach(item => {
        const count = item.getAttribute('data-slide-down')
        const delay = item.getAttribute('data-delay')
        gsap.set(item, {y:count ? count : 10,autoAlpha:0})
        gsap.to(item, {
            y:0,
            delay: delay ? delay : 0,
            duration:1,
            autoAlpha:1,
            ease: "power3.out",
            scrollTrigger: {
                trigger: item,
                start: 'top 85%',
                scrub: false
            },
        })
    })

    gsap.utils.toArray('.group_title_decor').forEach(item => {
        const splittingText = item.querySelector('[data-anim-splitting-scroll]')
        if (!splittingText) return

        const decorIcon = item.querySelectorAll('[data-decor-title]')
        const hasDecorIcon = decorIcon && decorIcon.length > 0

        const linesSplit = new SplitText(splittingText, {
            type: 'lines, words, chars',
            // mask: 'lines',
            linesClass: 'text-line',
        })

        if (hasDecorIcon) {
            gsap.set(decorIcon, {
                autoAlpha: 0,
                filter: 'blur(10px)'
            })
        }

        gsap.set(linesSplit.chars, {
            x: 50,
            autoAlpha:0,
            // rotate: 5,
            filter: 'blur(5px)'
        })

        const tlSplitLines = gsap.timeline({
            scrollTrigger: {
                trigger: item,
                start: windowWidth >= 1280 ? 'top 70%' : 'top 90%',
                scrub: false
            }
        })

        tlSplitLines.to(linesSplit.chars, {
            autoAlpha:1,
            x: 0,
            rotate: 0,
            duration: 2,
            stagger: 0.02,
            filter: 'blur(0px)',
            ease: 'expo.out'
        }, 0)

        if (hasDecorIcon) {
            const attrDelay = decorIcon[0].getAttribute('data-decor-title')
            const decorIconDelay = attrDelay ? parseFloat(attrDelay) : 0.7

            tlSplitLines.to(decorIcon, {
                // delay: decorIconDelay,
                filter: 'blur(0px)',
                autoAlpha: 1,
                duration: 1.5,
                ease: 'expo.out',
                stagger: 0.08
            }, '<=+1')
        }
    })
}

function initAccordion() {
    const accordion_section = document.querySelector('.accordion_section');
    if (!accordion_section) return

    const groups = gsap.utils.toArray('.js_accordion__group');
    const menus = gsap.utils.toArray('.js_accordion__menu');
    const animations = [];

    groups.forEach(group => createAnimation(group));

    menus.forEach(menu => {
        menu.addEventListener('click', () => toggleAnimation(menu));
    })

    function toggleAnimation(menu) {
        const selectedReversedState = menu.animation.reversed();
        animations.forEach(animation => animation.reverse());

        menu.animation.reversed(!selectedReversedState);
    }

    function createAnimation(element) {
        const menu = element.querySelector('.js_accordion__menu');
        const box = element.querySelector('.js_accordion__content');
        const icon_line = element.querySelector('.js_accordion__icon_line');
        const icon = element.querySelector('.js_accordion__icon');
        const content = element.querySelectorAll('.js_accordion__content p');

        gsap.set(box, {height: 'auto'})

        const tlAccordion = gsap.timeline({
            reversed: true,
            paused: !0,
            onComplete: () => {
            	ScrollTrigger.refresh()
            }
        });

        tlAccordion
            .from(box, {
                height: 0,
                duration: .6,
                ease: 'power3.inOut'
            })
            .to(icon, {
                duration: .6,
                rotateX: 180,
                ease: 'linear'
            }, '<')

        menu.animation = tlAccordion;
        animations.push(tlAccordion);
    }
}

function resetScrollToTop() {
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual'
    }

    if (!pendingApplyFormHashScroll && location.hash !== APPLY_FORM_HASH) {
        return
    }

    pendingApplyFormHashScroll = true

    const resetScrollTop = () => {
        window.scrollTo(0, 0)
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0

        if (mainWrapper) {
            mainWrapper.scrollTop = 0
        }

        if (scroll && typeof scroll.scrollTo === 'function') {
            scroll.scrollTo(0, { immediate: true })
        }
    }

    resetScrollTop()

    window.addEventListener('pageshow', event => {
        if (event.persisted && (pendingApplyFormHashScroll || location.hash === APPLY_FORM_HASH)) {
            resetScrollTop()
        }
    })
}

function initLangSwitcher() {
    const wrapper = document.querySelector('.wrapper_lang')
    if (!wrapper) return

        const btn = wrapper.querySelector('.btn_toggle_lang')

    document.addEventListener('click', e => {
        if (btn.contains(e.target)) {
            wrapper.classList.toggle('is_opened')
            return
        }

        if (!wrapper.contains(e.target)) {
            wrapper.classList.remove('is_opened')
        }
    })
}

function formContactPopup() {
    const openPopupButtons = document.querySelectorAll('[data-open-popup]')
    const popup = document.getElementById('contact_popup')

    if (!popup || !openPopupButtons.length) return

    const inner = popup.querySelector('.inner_popup')
    const closeBtn = popup.querySelectorAll('[data-close-popup]')
    const wrapHeadForm = popup.querySelector('.wrap_head_form')
    const form = popup.querySelector('#form_contact')
    const popupEmailInput = form.querySelector('input[name="email"]')
    const stepsWrapper = popup.querySelector('.steps-wrapper')
    const steps = Array.from(popup.querySelectorAll('.item_form_step'))
    const progressBars = Array.from(popup.querySelectorAll('.inside_acts'))
    const nextBtn = form.querySelector('button[type="submit"]')

    const formWrapper = popup.querySelector('.form_wrapper')
    const thanksWrapper = popup.querySelector('.thanks_wrapper')
    const stepsFooter = popup.querySelector('.steps_footer')

    let currentStep = 0

    gsap.set([popup, inner], { autoAlpha: 0 })
    gsap.set(popup, { display: 'none' })

    const tl = gsap.timeline({
        paused: true
    })

    tl
        .to(popup, {
            duration: .5,
            autoAlpha: 1,
            display: 'block'
        })
        .fromTo(
            inner,
            { scale: 0.9, autoAlpha: 0, y: 20 },
            { scale: 1, autoAlpha: 1, y: 0, duration: .5 },
            '<'
        )

    tl.eventCallback('onReverseComplete', () => {
        gsap.set(popup, { display: 'none' })
    })

    function resetPopupState() {
        if (!form) return

        form.reset()

        popup.querySelectorAll('.error').forEach(el => el.classList.remove('error'))

        const profile = document.querySelector('input[name="profile"]')
        if (profile) {
            profile.readOnly = false
        }

        if (formWrapper) {
            gsap.set(formWrapper, { autoAlpha: 1, y: 0, height: 'auto' })
        }
        if (thanksWrapper) {
            gsap.set(thanksWrapper, { autoAlpha: 0, height:0})
        }

        if (stepsFooter) {
            gsap.set(stepsFooter, { height: 'auto' })
        }

        currentStep = 0

        steps.forEach((step, i) => {
            if (i === 0) {
                gsap.set(step, { autoAlpha: 1, y: 0 })
            } else {
                gsap.set(step, { autoAlpha: 0, y: 0 })
            }
        })

        if (stepsWrapper && steps[0]) {
            const h = steps[0].offsetHeight
            if (h) stepsWrapper.style.height = h + 'px'
        }

        progressBars.forEach((bar, i) => {
            gsap.set(bar, { width: i === 0 ? '100%' : '0%' })
        })

        const head1 = popup.querySelector('.heading_txt_1')
        const head2 = popup.querySelector('.heading_txt_2')
        if (head1 && head2) {
            head1.classList.remove('invisible', 'opacity-0', 'translate-y-2')
            head2.classList.add('invisible')
            head2.classList.add('opacity-0')
            head2.classList.add('translate-y-2')
        }

        inner.classList.remove('is_next_step')

        const labels = nextBtn.querySelectorAll('.wrapper_btn_tx span')
            labels.forEach(span => {
            span.textContent = 'next'
        })
    }

    function openPopupFn(e) {
        if (e) e.preventDefault()

        const trigger = e?.currentTarget || e?.target?.closest('[data-open-popup]')
        
        resetPopupState()

        if (trigger && trigger.dataset.emailSource && popupEmailInput) {
            const sourceInput = document.querySelector(trigger.dataset.emailSource)
            const emailValue = sourceInput?.value?.trim()

            if (emailValue) {
                popupEmailInput.value = emailValue
            }
        }
        
        tl.play(0)

        requestAnimationFrame(() => {
            if (stepsWrapper && steps[currentStep]) {
                const h = steps[currentStep].offsetHeight
                if (h) stepsWrapper.style.height = h + 'px'
            }
        })

        if (trigger && trigger.dataset.skipFirstStep === 'true') {
            goToStep(1)
        }

        scroll.stop()
    }

    function closePopupFn() {
        scroll.start()
        tl.reverse()
    }

    function updateProgress(stepIndex) {
        progressBars.forEach((bar, i) => {
            const targetWidth = i <= stepIndex ? '100%' : '0%'
            gsap.to(bar, {
                delay:.1,
                width: targetWidth
            })
        })

        const labels = nextBtn.querySelectorAll('.wrapper_btn_tx span')
        const isLast = stepIndex === steps.length - 1
        labels.forEach(span => {
            span.textContent = isLast ? 'submit' : 'next'
        })
    }

    function updateInnerClass() {
        if (currentStep > 0) {
            inner.classList.add('is_next_step')
        } else {
            inner.classList.remove('is_next_step')
        }
    }

    function validateFields(container) {
        const fields = container.querySelectorAll('input, textarea, select')
        let isValid = true
        let firstInvalid = null
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        fields.forEach(field => {
            let value = String(field.value || '').trim()
            if (field.tagName === 'SELECT' && field.selectedIndex === 0) {
                value = ''
            }

            if (field.type === 'email' && value) {
                if (!emailRegex.test(value)) {
                    value = ''
                }
            }

            const wrapper = field.closest('.form-field') || field

            if (!value) {
                isValid = false
                if (!firstInvalid) firstInvalid = field
                    field.classList.add('error')
                wrapper.classList.add('error')
            } else {
                field.classList.remove('error')
                wrapper.classList.remove('error')
            }
        })

        if (!isValid && firstInvalid) firstInvalid.focus()
            return isValid
    }

    function validateCurrentStep() {
        return validateFields(steps[currentStep])
    }

    function validateAllSteps() {
        let isValid = true
        steps.forEach(step => {
            if (!validateFields(step)) isValid = false
        })
        return isValid
    }

    function goToStep(nextIndex) {
        if (nextIndex === currentStep) return
        if (nextIndex < 0 || nextIndex >= steps.length) return

        const currentEl = steps[currentStep]
        const nextEl = steps[nextIndex]

        let oldHeight = 0
        let newHeight = 0

        if (stepsWrapper) {
            oldHeight = stepsWrapper.offsetHeight || 0
            newHeight = nextEl.offsetHeight || 0
        }

        steps.forEach((step, i) => {
            if (i !== nextIndex) {
                gsap.to(step, { autoAlpha: 0, y: 0, duration: .5 })
            }
        })

        if (currentEl !== nextEl) {
            gsap.to(currentEl, {
                autoAlpha: 0,
                y: -10,
                duration: .5
            })
        }

        gsap.fromTo(
            nextEl,
            { autoAlpha: 0, y: 10, duration: .5 },
            { autoAlpha: 1, y: 0, duration: .5 }
        )

        if (stepsWrapper && newHeight) {
            if (!oldHeight) {
                stepsWrapper.style.height = newHeight + 'px'
            } else {
                gsap.fromTo(
                    stepsWrapper,
                    { height: oldHeight },
                    {
                        height: newHeight,
                        duration: .5,
                        onComplete() {
                            stepsWrapper.style.height = newHeight + 'px'
                        }
                    }
                )
            }
        }

        currentStep = nextIndex
        updateProgress(currentStep)
        updateInnerClass()
    }

    steps.forEach((step, i) => {
        if (i === 0) {
            gsap.set(step, { autoAlpha: 1, y: 0, duration: .5 })
        } else {
            gsap.set(step, { autoAlpha: 0, y: 0, duration: .5 })
        }
    })

    updateProgress(currentStep)
    updateInnerClass()

    openPopupButtons.forEach(btn => {
        btn.addEventListener('click', openPopupFn)
    })

    if (closeBtn) {
        closeBtn.forEach(item => {
            item.addEventListener('click', e => {
                e.preventDefault()
                closePopupFn()
            })
        })
    }

    popup.addEventListener('click', e => {
        if (!inner.contains(e.target)) {
            closePopupFn()
        }
    })

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && tl.progress() > 0) {
            closePopupFn()
        }
    })

    if (wrapHeadForm) {
        wrapHeadForm.addEventListener('click', e => {
            e.preventDefault()
            if (currentStep > 0) {
                goToStep(currentStep - 1)
            }
        })
    }

    function afterSubmit() {
        if (!formWrapper || !thanksWrapper) return

        const emailInput = document.getElementById('email_start_form')
        const tlEnd = gsap.timeline()

        gsap.set(thanksWrapper, { display: 'block', height: 'auto' })
        const targetHeight = thanksWrapper.offsetHeight || thanksWrapper.scrollHeight || 0
        gsap.set(thanksWrapper, { height: 0,display: 'none', autoAlpha:1 })
        gsap.set('.thanks_wrapper > div', { autoAlpha:0 })

        tlEnd
        .to(formWrapper, {
            autoAlpha: 0,
            duration: .5
        })
        .to(formWrapper, {
            height: 0,
            duration: .5
        }, '<+=.2')

        .to(stepsFooter, {height: 0, duration: .5}, '<')

        .fromTo(thanksWrapper,{display: 'block',height: 0,duration: .5},{height: targetHeight,onComplete() {thanksWrapper.style.height = 'auto'}},'<')
        .to('.thanks_wrapper > div', {autoAlpha: 1,stagger:.04, duration: .5, onComplete() {form.reset();emailInput.value = ''}}, '>-=.2')
    }

    form.addEventListener('submit', e => {
        e.preventDefault()
        const formData = new FormData(e.currentTarget)

        const isLast = currentStep === steps.length - 1

        if (!isLast) {
            if (!validateCurrentStep()) return
            goToStep(currentStep + 1)
            return
        }

        if (!validateAllSteps()) {
            return
        }else {
            nextBtn.classList.add('loading')
            fetch('/vendor/form-contact.php', {
               method: 'POST',
               body: formData
           })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network error: ' + response.status)
                }
                return response.json()
            })
            .then(data => {
                if (!data.success) {
                    console.error('Server error:', data.error)
                    return
                }
                afterSubmit()
            })
            .catch(err => {
                console.error('fetch error:', err)
            })
            .finally(() => {
                nextBtn.classList.remove('loading')
            })
        }
    })

    initEmailButton()
    tiktokFieldLogic()
}

function initFreeModulePopup() {
    const popup = document.getElementById('free_module_popup')
    const openButtons = document.querySelectorAll('[data-free-lesson-modal-open]')
    if (!popup || !openButtons.length) return

    const panel = popup.querySelector('.free-module-popup__panel')
    const closeButtons = popup.querySelectorAll('[data-free-lesson-modal-close]')

    if (!panel) return

    gsap.set([popup, panel], { autoAlpha: 0 })
    gsap.set(popup, { display: 'none' })

    const timeline = gsap.timeline({
        paused: true,
    })

    timeline
        .to(popup, {
            duration: .5,
            autoAlpha: 1,
            display: 'block',
        })
        .fromTo(
            panel,
            { scale: 0.9, autoAlpha: 0, y: 20 },
            { scale: 1, autoAlpha: 1, y: 0, duration: .5 },
            '<'
        )

    timeline.eventCallback('onReverseComplete', () => {
        popup.classList.add('hidden')
        gsap.set(popup, { display: 'none' })
    })

    function openPopup(event) {
        if (event) event.preventDefault()

        popup.classList.remove('hidden')
        popup.setAttribute('aria-hidden', 'false')
        document.documentElement.classList.add('lenis-stopped')
        scroll?.stop?.()
        timeline.play(0)
    }

    function closePopup() {
        popup.setAttribute('aria-hidden', 'true')
        document.documentElement.classList.remove('lenis-stopped')
        scroll?.start?.()
        timeline.reverse()
    }

    openButtons.forEach(button => {
        button.addEventListener('click', openPopup)
    })

    closeButtons.forEach(button => {
        button.addEventListener('click', event => {
            event.preventDefault()
            closePopup()
        })
    })

    popup.addEventListener('click', event => {
        if (!panel.contains(event.target)) {
            closePopup()
        }
    })

    document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
            closePopup()
        }
    })
}

function tiktokFieldLogic() {
    const followers = document.getElementById('followers')
    if (!followers) {
        return
    }

    const profile = document.querySelector('input[name="profile"]')
    if (!profile) {
        return
    }

    const NO_PROFILE_TEXT = 'No TikTok profile'
    const NO_PROFILE_VALUE = '-'

    const apply = () => {
        const selectedText = (followers.options[followers.selectedIndex]?.text || '').trim()
        const isNoProfile = selectedText === NO_PROFILE_TEXT

        if (isNoProfile) {
            profile.value = NO_PROFILE_VALUE
            profile.readOnly = true
            profile.setAttribute('aria-disabled', 'true')
            profile.classList.remove('error')
            followers.classList.remove('error')
        } else {
            if (profile.value === NO_PROFILE_VALUE) profile.value = ''
                profile.readOnly = false
            profile.removeAttribute('aria-disabled')
        }
    }

    followers.addEventListener('change', apply)
    apply()
}

function initEmailButton() {
 const emailInput = document.getElementById('email_start_form')
 const startBtn   = document.getElementById('btn_get_start')
 if (!emailInput || !startBtn) return

    const validationMode = (emailInput.dataset.validationMode || '').trim().toLowerCase()
    const form = emailInput.closest('form')

    const handler = () => {
        const value = emailInput.value.trim()
        const normalizedId = value.toUpperCase().replace(/[^A-Z0-9-]/g, '').slice(0, 24)

        if (validationMode === 'certificate-id') {
            if (value !== normalizedId) {
                emailInput.value = normalizedId
            }
        }

        const isValid =
            validationMode === 'certificate-id'
                ? normalizedId.length >= 3
                : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)

        startBtn.disabled = !isValid
        startBtn.classList.toggle('opacity-50', !isValid)
        startBtn.classList.toggle('pointer-events-none', !isValid)
    }

    emailInput.addEventListener('input', handler)

    if (form && validationMode === 'certificate-id') {
        form.addEventListener('submit', event => {
            const normalizedId = emailInput.value.trim().toUpperCase().replace(/[^A-Z0-9-]/g, '').slice(0, 24)

            if (normalizedId.length < 3) {
                event.preventDefault()
                handler()
                return
            }

            emailInput.value = normalizedId
        })
    }

    handler()
}

function menuMobile() {
  const menu = document.getElementById('menu_site')
  const openBtns = document.querySelectorAll('[data-open-menu]')
  const closeBtns = menu ? menu.querySelectorAll('[data-close-popup]') : []
  const inside = menu ? menu.querySelectorAll('.item_row_menu') : []
  const hashLinks = menu
      ? menu.querySelectorAll('a[data-apply-form-hash-link], a[data-certificate-hash-link], a[href="#apply-form"], a[href="/#apply-form"], a[href$="#apply-form"], a[href="#certificate_id"], a[href="/course#certificate_id"], a[href$="#certificate_id"]')
      : []

  if (!menu || !openBtns.length) return

  gsap.set(menu, { yPercent: -100})
  gsap.set(inside, { autoAlpha:0,y:-10,scale:.95 })

  const tl = gsap.timeline({ paused: true })
    .set(menu, { display: 'block' })
    .to(menu, { yPercent: 0,duration:.7 })
    .to(inside, { autoAlpha:1, stagger:-.04, scale:1,y:0,duration:.7 }, '<+=.2')

  tl.eventCallback('onReverseComplete', () => {
    gsap.set(menu, { display: 'none' })
  })

  const open = () => tl.timeScale(1).play()
  const close = () => tl.timeScale(2).reverse()

  openBtns.forEach(btn => btn.addEventListener('click', open))
  closeBtns.forEach(btn => btn.addEventListener('click', close))
  hashLinks.forEach(link => link.addEventListener('click', close))
}

function waveSections() {
    const waveItem = document.querySelectorAll('.wave_wrapper')
    if (waveItem) {
        waveItem.forEach(item => {
            const path1 = item.querySelector('.wave1')
            if (path1) {
                const pointSpacing = 20
                const width = 1920
                const baseY = 75

                function updateWavePaths(offset) {
                    const points1 = []
                    const points2 = []

                    for (let x = 0; x <= width; x += pointSpacing) {
                        const y1 = baseY + 10 * Math.sin(x * 0.002 + offset)
                        const y2 = baseY + 15 * Math.sin(x * 0.003 + offset + 0.2)

                        points1.push(`${x},${y1}`)
                        points2.push(`${x},${y2}`)
                    }

                    const pathData1 = `M0,150 L0,75 ${points1.join(' ')} L${width},150 Z`
                    const pathData2 = `M0,150 L0,75 ${points2.join(' ')} L${width},150 Z`

                    path1.setAttribute('d', pathData1)
                }

                gsap.ticker.add(time => {
                    const offset = time * 1.5 
                    updateWavePaths(offset)
                })
            }
        })
    }
}

function initLazyVideos() {
    initObserverHub()
  const supportsHover = matchMedia('(hover: hover) and (pointer: fine)').matches

  const videos = document.querySelectorAll('[data-video-lazy]')
  if(videos.length) {
      videos.forEach(video => {
        const src = (video.dataset.videoSrc || '').trim()
        if (!src) return

        if (!video.dataset.videoStatus) {
          video.dataset.videoStatus = 'not-loaded'
        }

        if (video.getAttribute('src') === null) {
          video.setAttribute('src', '')
        }

        const lazyAttr = (video.getAttribute('data-video-lazy') || '').toLowerCase()
        const isHoverRequested = lazyAttr === 'hover'
        const disableAutoplay = video.hasAttribute('data-video-no-autoplay')
        const useHoverMode = isHoverRequested && supportsHover

        let hydrating = false
        let hydrated = false
        let hoverLeaveTimeout = null

        function startHydration() {
          if (hydrating || hydrated) return
          if (!src) return

          hydrating = true

          video.muted = true
          video.playsInline = true
          video.preload = 'metadata'

          if (!video.getAttribute('src')) {
            video.setAttribute('src', src)
          }

          try {
            video.load()
          } catch (err) {}

          function onLoaded() {
            video.removeEventListener('loadeddata', onLoaded)
            video.removeEventListener('canplay', onLoaded)

            video.dataset.videoStatus = 'loaded'
            hydrating = false
            hydrated = true
          }

          video.addEventListener('loadeddata', onLoaded)
          video.addEventListener('canplay', onLoaded)
        }

        function setupHoverMode() {
          const hoverTarget = video.closest('[data-video-lazy-hover]') || video

          function onEnter() {
            if (hoverLeaveTimeout) {
              clearTimeout(hoverLeaveTimeout)
              hoverLeaveTimeout = null
            }

            if (!hydrated) {
              startHydration()
            }

            if (!video.getAttribute('src')) {
              video.setAttribute('src', src)
            }

            video.dataset.videoStatus = 'loaded'

            try {
              video.currentTime = 0
            } catch (err) {}

            try {
              video.play()
            } catch (err) {}
          }

          function onLeave() {
            video.dataset.videoStatus = 'not-loaded'

            hoverLeaveTimeout = setTimeout(() => {
              try {
                video.pause()
              } catch (err) {}

              try {
                video.currentTime = 0
              } catch (err) {}

              hoverLeaveTimeout = null
            }, 200)
          }

          hoverTarget.addEventListener('mouseenter', onEnter)
          hoverTarget.addEventListener('mouseleave', onLeave)

          if (window.addDisposable) {
            addDisposable(() => {
              hoverTarget.removeEventListener('mouseenter', onEnter)
              hoverTarget.removeEventListener('mouseleave', onLeave)
              if (hoverLeaveTimeout) {
                clearTimeout(hoverLeaveTimeout)
                hoverLeaveTimeout = null
              }
            })
          }

          const disposeObserver = observeWith(video, { threshold: 0 }, entry => {
            if (!entry.isIntersecting) {
              try {
                video.pause()
              } catch (err) {}
            }
          })

          if (window.addDisposable && disposeObserver) {
            addDisposable(disposeObserver)
          }
        }

        function setupScrollMode() {
          const disposeObserver = observeWith(video, { threshold: 0.15 }, entry => {
            if (entry.isIntersecting) {
              if (!hydrated) {
                startHydration()
              }
              video.dataset.videoStatus = 'loaded'
              try {
                video.play()
              } catch (err) {}
            } else {
              try {
                video.pause()
              } catch (err) {}
            }
          })

          if (window.addDisposable && disposeObserver) {
            addDisposable(disposeObserver)
          }

          if (video.dataset.videoStatus === 'loaded' && !hydrated) {
            startHydration()
          }
        }

        if (disableAutoplay) {
          // Keep manual videos hidden by default so sibling <img> acts as preview.
          // They can be shown/played later by explicit custom logic.
          video.dataset.videoStatus = 'not-loaded'
          return
        }

        if (useHoverMode) {
          setupHoverMode()
        } else {
          setupScrollMode()
        }
      })
  }
}

function initManualToggleVideos(scope = document) {
    const wrappers = scope.querySelectorAll('[data-video-manual-toggle]')
    if (!wrappers.length) return

    const manualEntries = []

    const pauseEntry = entry => {
        if (!entry || !entry.video) return
        if (typeof entry.stopVideo === 'function') {
            entry.stopVideo()
            return
        }
        try {
            entry.video.pause()
        } catch (err) {}
        entry.setButtonState(false)
    }

    const pauseOtherEntries = activeVideo => {
        manualEntries.forEach(entry => {
            if (!entry?.video || entry.video === activeVideo) return
            if (!entry.video.paused && !entry.video.ended) {
                pauseEntry(entry)
            }
        })
    }

    wrappers.forEach(wrapper => {
        if (wrapper.dataset.videoManualToggleBound === '1') return
        wrapper.dataset.videoManualToggleBound = '1'

        const video = wrapper.querySelector('[data-video-manual-player]') || wrapper.querySelector('video[data-video-no-autoplay][data-video-lazy]')
        const overlay = wrapper.querySelector('[data-video-manual-overlay]') || wrapper.querySelector('.absolute.inset-0.bg-black')
        const button = wrapper.querySelector('[data-video-manual-button]')
        const playIcon = button?.querySelector('[data-video-manual-icon-play]')
        const pauseIcon = button?.querySelector('[data-video-manual-icon-pause]')
        const source = (video?.dataset.videoSrc || '').trim()
        let hasStartedPlayback = video.dataset.videoStatus === 'loaded'
        let isLoading = false
        let playRequestId = 0

        if (!video || !button) return

        const entry = { video: null, setButtonState: () => {}, stopVideo: null }

        video.controls = false
        const overlayBaseOpacity = overlay ? (Number.parseFloat(getComputedStyle(overlay).opacity || '') || 0.2) : 0
        const loadingIndicator = document.createElement('div')
        loadingIndicator.setAttribute('data-video-manual-loading', '')
        loadingIndicator.setAttribute('aria-hidden', 'true')
        loadingIndicator.className = 'absolute left-1/2 top-1/2 z-[5] -translate-x-1/2 -translate-y-1/2 pointer-events-none opacity-0 transition-opacity duration-200'
        loadingIndicator.innerHTML = '<span class="block size-10 xl:size-[calc(var(--px)*40)] rounded-full border xl:border-[calc(var(--px)*2)] border-white/35 border-t-white animate-spin"></span>'
        wrapper.appendChild(loadingIndicator)

        const setButtonState = isPlaying => {
            playIcon?.classList.toggle('opacity-0', isPlaying)
            playIcon?.classList.toggle('scale-0', isPlaying)
            pauseIcon?.classList.toggle('opacity-0', !isPlaying)
            pauseIcon?.classList.toggle('scale-0', !isPlaying)
            button.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video')
        }

        const setLoadingState = isActive => {
            isLoading = isActive
            wrapper.setAttribute('aria-busy', isActive ? 'true' : 'false')
            button.classList.toggle('pointer-events-none', isActive)
            button.classList.toggle('opacity-70', isActive)
            loadingIndicator.classList.toggle('opacity-0', !isActive)
            loadingIndicator.classList.toggle('opacity-100', isActive)
        }

        const setOverlayState = (isPlaying, immediate = false) => {
            if (!overlay) return
            gsap.to(overlay, {
                opacity: isPlaying ? 0 : overlayBaseOpacity,
                duration: immediate ? 0 : 0.24,
                ease: 'power2.out',
                overwrite: true,
            })
        }

        const ensureVideoReady = () => {
            if (!video.getAttribute('src') && source) {
                video.setAttribute('src', source)
                try {
                    video.load()
                } catch (err) {}
            }
        }

        const waitForVideoReady = (timeoutMs = 15000) => {
            if (video.readyState >= 2) {
                return Promise.resolve(true)
            }

            return new Promise(resolve => {
                let done = false

                const finish = value => {
                    if (done) return
                    done = true
                    clearTimeout(timeoutId)
                    video.removeEventListener('loadeddata', onReady)
                    video.removeEventListener('canplay', onReady)
                    video.removeEventListener('error', onFail)
                    resolve(value)
                }

                const onReady = () => finish(true)
                const onFail = () => finish(false)

                const timeoutId = setTimeout(() => finish(false), timeoutMs)

                video.addEventListener('loadeddata', onReady, { once: true })
                video.addEventListener('canplay', onReady, { once: true })
                video.addEventListener('error', onFail, { once: true })
            })
        }

        const fadeVolumeIn = () => {
            gsap.killTweensOf(video, 'volume')
            video.muted = false
            video.defaultMuted = false
            if (!Number.isFinite(video.volume) || video.volume <= 0) {
                video.volume = 0
            }
            gsap.to(video, {
                volume: 1,
                duration: 0.32,
                ease: 'power2.out',
                overwrite: true
            })
        }

        const playVideo = async () => {
            const requestId = ++playRequestId
            ensureVideoReady()
            if (video.readyState < 2) {
                setLoadingState(true)
            }

            const ready = await waitForVideoReady()
            if (requestId !== playRequestId) return
            setLoadingState(false)

            if (!ready) {
                video.dataset.videoStatus = hasStartedPlayback ? 'loaded' : 'not-loaded'
                setOverlayState(false)
                setButtonState(false)
                return
            }

            pauseOtherEntries(video)
            setOverlayState(true)
            fadeVolumeIn()

            try {
                const playPromise = video.play()
                if (playPromise && typeof playPromise.catch === 'function') {
                    await playPromise
                }
            } catch (err) {
                video.dataset.videoStatus = hasStartedPlayback ? 'loaded' : 'not-loaded'
                setOverlayState(false)
                setButtonState(false)
            }
        }

        const pauseVideo = (options = {}) => {
            playRequestId += 1
            const shouldResetTime = Boolean(options.resetTime)
            try {
                video.pause()
            } catch (err) {}
            if (shouldResetTime) {
                try {
                    video.currentTime = 0
                } catch (err) {}
            }
            setLoadingState(false)
            video.dataset.videoStatus = hasStartedPlayback ? 'loaded' : 'not-loaded'
            setOverlayState(false)
            setButtonState(false)
        }

        const toggleVideo = () => {
            if (isLoading) return
            if (video.paused || video.ended) {
                playVideo()
            } else {
                pauseVideo()
            }
        }

        const onWrapperClick = event => {
            if (event.target?.closest('a')) return
            event.preventDefault()
            toggleVideo()
        }

        const onVideoPlay = () => {
            hasStartedPlayback = true
            setLoadingState(false)
            video.dataset.videoStatus = 'loaded'
            setOverlayState(true)
            setButtonState(true)
        }

        const onVideoPause = () => {
            setLoadingState(false)
            video.dataset.videoStatus = hasStartedPlayback ? 'loaded' : 'not-loaded'
            setOverlayState(false)
            setButtonState(false)
        }

        const onVideoEnded = () => {
            pauseVideo({ resetTime: true })
        }

        entry.video = video
        entry.setButtonState = setButtonState
        entry.stopVideo = () => pauseVideo()
        manualEntries.push(entry)

        setButtonState(false)
        setLoadingState(false)
        setOverlayState(false, true)

        wrapper.addEventListener('click', onWrapperClick)
        video.addEventListener('play', onVideoPlay)
        video.addEventListener('pause', onVideoPause)
        video.addEventListener('ended', onVideoEnded)

        const disposeObserver = observeWith(video, { threshold: 0.15 }, ioEntry => {
            if (!ioEntry.isIntersecting) {
                pauseEntry(entry)
            }
        })

        if (window.addDisposable) {
            addDisposable(() => {
                wrapper.removeEventListener('click', onWrapperClick)
                video.removeEventListener('play', onVideoPlay)
                video.removeEventListener('pause', onVideoPause)
                video.removeEventListener('ended', onVideoEnded)
                loadingIndicator.remove()
                const index = manualEntries.indexOf(entry)
                if (index !== -1) {
                    manualEntries.splice(index, 1)
                }
            })
            if (disposeObserver) {
                addDisposable(disposeObserver)
            }
        }
    })
}

function initFounderSlider(scope = document) {
    const root = scope.querySelector('[data-founder-slider]')
    if (!root) return

    const nextButton = root.querySelector('[data-founder-next]')
    const prevButton = root.querySelector('[data-founder-prev]')
    const quoteNode = root.querySelector('[data-founder-quote]')
    const fullQuoteNodes = Array.from(root.querySelectorAll('[data-founder-quote-2]'))
    const quoteTargets = [quoteNode, ...fullQuoteNodes].filter(Boolean)
    const quoteToggleButton = root.querySelector('[data-founder-toggle]')
    const popup = document.getElementById('founder_info_popup')
    const popupInner = popup?.querySelector('.inner_founder_popup')
    const popupNameNode = popup?.querySelector('[data-founder-popup-name]')
    const popupDescriptionNode = popup?.querySelector('[data-founder-popup-description]')
    const popupCloseButtons = popup ? popup.querySelectorAll('[data-close-founder-popup]') : []

    const imageLayers = Array.from(root.querySelectorAll('[data-founder-image]'))
        .sort((a, b) => Number(a.dataset.founderImage) - Number(b.dataset.founderImage))

    const socialCards = Array.from(root.querySelectorAll('[data-founder-social-card]'))
        .sort((a, b) => Number(a.dataset.founderSocialCard) - Number(b.dataset.founderSocialCard))

    const socialTitles = Array.from(root.querySelectorAll('[data-founder-social-title]'))
        .sort((a, b) => Number(a.dataset.founderSocialTitle) - Number(b.dataset.founderSocialTitle))

    const socialIcons = Array.from(root.querySelectorAll('[data-founder-social-icon]'))
        .sort((a, b) => Number(a.dataset.founderSocialIcon) - Number(b.dataset.founderSocialIcon))

    const socialHandles = Array.from(root.querySelectorAll('[data-founder-social-handle]'))
        .sort((a, b) => Number(a.dataset.founderSocialHandle) - Number(b.dataset.founderSocialHandle))

    const socialMetrics = Array.from(root.querySelectorAll('[data-founder-social-metric]'))
        .sort((a, b) => Number(a.dataset.founderSocialMetric) - Number(b.dataset.founderSocialMetric))

    if (!nextButton || !prevButton || !quoteNode || !quoteToggleButton || imageLayers.length < 3 || socialCards.length < 3) {
        return
    }

    const FOUNDER_SHORT_LINE_COUNT = 7
    const FOUNDER_SHORT_LINE_COUNT_MOBILE = 5

    const normalizeFounderText = value =>
        String(value || '')
            .replace(/\r/g, '')
            .replace(/[ \t]+\n/g, '\n')
            .replace(/\n[ \t]+/g, '\n')
            .trim()

    const extractFounderText = (node, paragraphSeparator = ' ') => {
        if (!node) return ''

        const paragraphs = Array.from(node.querySelectorAll('p'))
            .map(paragraph => normalizeFounderText(paragraph.textContent))
            .filter(Boolean)

        if (paragraphs.length) {
            return paragraphs.join(paragraphSeparator)
        }

        return normalizeFounderText(node.textContent)
    }

    const readFounderNodeText = (parent, selector) => {
        const node = parent?.querySelector(selector)
        return extractFounderText(node, ' ')
    }

    const readFounderLongParagraphs = parent => {
        const node = parent?.querySelector('[data-founder-content-quote-full]')
        if (!node) return []

        const paragraphs = Array.from(node.querySelectorAll('p'))
            .map(paragraph => normalizeFounderText(paragraph.textContent))
            .filter(Boolean)

        if (paragraphs.length) {
            return paragraphs
        }

        const fallbackText = normalizeFounderText(node.textContent)
        return fallbackText ? [fallbackText] : []
    }

    const escapeFounderHtml = value =>
        String(value || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')

    const renderFounderParagraphsHtml = paragraphs =>
        (paragraphs || [])
            .map(paragraph => `<p>${escapeFounderHtml(paragraph)}</p>`)
            .join('')

    const founderDataRoot = root.querySelector('[data-founder-data]')
    const founders = founderDataRoot
        ? Array.from(founderDataRoot.querySelectorAll('[data-founder-content-item]')).map(item => {
            const quoteFullParagraphs = readFounderLongParagraphs(item)
            const socials = Array.from(item.querySelectorAll('[data-founder-content-social]')).map(social => ({
                title: readFounderNodeText(social, '[data-founder-content-social-title]'),
                icon: readFounderNodeText(social, '[data-founder-content-social-icon]'),
                handle: readFounderNodeText(social, '[data-founder-content-social-handle]'),
                metric: readFounderNodeText(social, '[data-founder-content-social-metric]'),
            }))

            return {
                name: readFounderNodeText(item, '[data-founder-content-name]'),
                quote: readFounderNodeText(item, '[data-founder-content-quote]'),
                quoteFull: quoteFullParagraphs.join('\n\n'),
                quoteFullParagraphs,
                socials,
            }
        }).filter(founder =>
            founder.name &&
            founder.quote &&
            founder.quoteFull &&
            founder.quoteFullParagraphs.length &&
            founder.socials.length >= 3
        )
        : []

    if (founders.length < 3) return

    let activeIndex = 0
    let slideTimeline = null
    let popupTimeline = null
    let isPopupOpen = false
    let isSlideAnimating = false

    const secondaryQuoteNodes = quoteTargets.filter(node => node !== quoteNode)
    const cardTargets = [...socialCards]

    const setFounderNavLocked = locked => {
        const action = locked ? 'true' : 'false'
        ;[nextButton, prevButton].forEach(button => {
            button.setAttribute('aria-disabled', action)
            button.style.pointerEvents = locked ? 'none' : ''
            button.style.opacity = locked ? '0.7' : ''
            if ('disabled' in button) {
                button.disabled = locked
            }
        })
    }

    const getFounderShortLineCount = () =>
        window.innerWidth < 1279 ? FOUNDER_SHORT_LINE_COUNT_MOBILE : FOUNDER_SHORT_LINE_COUNT

    const applyQuoteClamp = () => {
        const shortLineCount = getFounderShortLineCount()

        quoteNode.style.display = '-webkit-box'
        quoteNode.style.webkitBoxOrient = 'vertical'
        quoteNode.style.webkitLineClamp = String(shortLineCount)
        quoteNode.style.overflow = 'hidden'
        quoteNode.style.textOverflow = 'ellipsis'

        const computedStyles = window.getComputedStyle(quoteNode)
        let lineHeight = Number.parseFloat(computedStyles.lineHeight || '')
        if (!Number.isFinite(lineHeight)) {
            const fontSize = Number.parseFloat(computedStyles.fontSize || '')
            lineHeight = Number.isFinite(fontSize) ? fontSize * 1.2 : 24
        }

        quoteNode.style.maxHeight = `${Math.round(lineHeight * shortLineCount)}px`
    }

    const applyQuoteContent = (founder, timeline = null, startAt = 0.08) => {
        quoteNode.textContent = founder.quote
        fullQuoteNodes.forEach(targetNode => {
            const targetParent = targetNode.parentElement || targetNode
            const previousHeight = targetParent.getBoundingClientRect().height
            targetNode.innerHTML = renderFounderParagraphsHtml(founder.quoteFullParagraphs)

            if (!timeline) {
                targetParent.style.height = 'auto'
                targetParent.style.overflow = ''
                targetParent.style.willChange = 'auto'
                return
            }

            const nextHeight = Math.max(1, targetParent.scrollHeight)
            const fromHeight = Math.max(1, Math.round(previousHeight))
            const toHeight = Math.max(1, Math.round(nextHeight))

            targetParent.style.overflow = 'hidden'
            targetParent.style.height = `${fromHeight}px`
            targetParent.style.willChange = 'height'

            gsap.killTweensOf(targetParent)

            if (Math.abs(toHeight - fromHeight) < 1) {
                targetParent.style.height = 'auto'
                targetParent.style.overflow = ''
                targetParent.style.willChange = 'auto'
                return
            }

            timeline.to(targetParent, {
                height: toHeight,
                duration: 0.32,
                ease: 'power1.out',
                overwrite: false,
                onComplete: () => {
                    targetParent.style.height = 'auto'
                    targetParent.style.overflow = ''
                    targetParent.style.willChange = 'auto'
                },
                onInterrupt: () => {
                    targetParent.style.height = 'auto'
                    targetParent.style.overflow = ''
                    targetParent.style.willChange = 'auto'
                },
            }, startAt)
        })
        applyQuoteClamp()
        quoteToggleButton.setAttribute('aria-expanded', 'false')
    }

    const animateSecondaryQuotesIn = (timeline, startAt = 0.2) => {
        if (!timeline || !secondaryQuoteNodes.length) return

        gsap.set(secondaryQuoteNodes, {
            autoAlpha: 0,
            y: 16,
            scale: 0.988,
            filter: 'blur(10px)',
            transformOrigin: '50% 100%',
        })

        timeline.to(secondaryQuoteNodes, {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            filter: 'blur(0px)',
            duration: 0.54,
            ease: 'power3.out',
            force3D: true,
        }, startAt)
    }

    const animateTextSwap = (node, nextText, timeline = null, startAt = 0, options = {}) => {
        if (!node) return
        const targetText = normalizeFounderText(nextText)
        const currentText = normalizeFounderText(node.textContent)
        if (currentText === targetText) return

        if (!timeline) {
            node.textContent = targetText
            return
        }

        const parent = node.parentElement
        if (!parent) {
            node.textContent = targetText
            return
        }

        const parentStyles = window.getComputedStyle(parent)
        if (parentStyles.position === 'static') {
            parent.style.position = 'relative'
        }

        const nodeRect = node.getBoundingClientRect()
        const parentRect = parent.getBoundingClientRect()
        if (!nodeRect.width && !nodeRect.height) {
            node.textContent = targetText
            return
        }

        const ghostNode = node.cloneNode(true)
        ghostNode.setAttribute('data-founder-content-ghost', '')
        ghostNode.setAttribute('aria-hidden', 'true')
        ghostNode.style.position = 'absolute'
        ghostNode.style.left = `${nodeRect.left - parentRect.left}px`
        ghostNode.style.top = `${nodeRect.top - parentRect.top}px`
        ghostNode.style.width = `${nodeRect.width}px`
        ghostNode.style.height = `${nodeRect.height}px`
        ghostNode.style.margin = '0'
        ghostNode.style.pointerEvents = 'none'
        ghostNode.style.zIndex = '2'
        parent.appendChild(ghostNode)

        const inY = Number.isFinite(options.inY) ? options.inY : 22
        const outY = Number.isFinite(options.outY) ? options.outY : -14
        const inDelay = Number.isFinite(options.inDelay) ? options.inDelay : 0.05
        const durationOut = Number.isFinite(options.durationOut) ? options.durationOut : 0.42
        const durationIn = Number.isFinite(options.durationIn) ? options.durationIn : 0.58

        node.textContent = targetText
        gsap.set(node, { autoAlpha: 0, y: inY, scale: 0.988 })

        timeline.to(ghostNode, {
            autoAlpha: 0,
            y: outY,
            scale: 1.01,
            duration: durationOut,
            ease: 'nbs',
            onComplete: () => {
                ghostNode.remove()
            },
        }, startAt)

        timeline.to(node, {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: durationIn,
            ease: 'nbs',
            force3D: true,
        }, startAt + inDelay)
    }

    const splitFounderSocialTitle = value => {
        const title = normalizeFounderText(value)
        if (!title) {
            return { name: '', suffix: '' }
        }

        const possessiveMatch = title.match(/^(.+?[\u2019']s)\s+(.*)$/i)
        if (possessiveMatch) {
            return {
                name: possessiveMatch[1],
                suffix: possessiveMatch[2] || '',
            }
        }

        const firstSpaceIndex = title.indexOf(' ')
        if (firstSpaceIndex === -1) {
            return { name: title, suffix: '' }
        }

        return {
            name: title.slice(0, firstSpaceIndex),
            suffix: title.slice(firstSpaceIndex + 1),
        }
    }

    const ensureFounderSocialTitleNodes = titleNode => {
        if (!titleNode) return null

        let nameShellNode = titleNode.querySelector('[data-founder-social-name-shell]')
        let nameNode = titleNode.querySelector('[data-founder-social-name]')
        let suffixNode = titleNode.querySelector('[data-founder-social-title-suffix]')
        const titleParts = splitFounderSocialTitle(titleNode.textContent)

        if (!nameShellNode && nameNode) {
            nameShellNode = document.createElement('span')
            nameShellNode.setAttribute('data-founder-social-name-shell', '')
            nameNode.parentNode?.insertBefore(nameShellNode, nameNode)
            nameShellNode.appendChild(nameNode)
        }

        if (!nameNode || !suffixNode || !nameShellNode) {
            titleNode.textContent = ''

            nameShellNode = document.createElement('span')
            nameShellNode.setAttribute('data-founder-social-name-shell', '')

            nameNode = document.createElement('span')
            nameNode.setAttribute('data-founder-social-name', '')
            nameNode.textContent = titleParts.name

            suffixNode = document.createElement('span')
            suffixNode.setAttribute('data-founder-social-title-suffix', '')
            suffixNode.textContent = titleParts.suffix ? ` ${titleParts.suffix}` : ''

            nameShellNode.appendChild(nameNode)
            titleNode.appendChild(nameShellNode)
            titleNode.appendChild(suffixNode)
        }

        nameShellNode.style.display = 'inline-block'
        nameShellNode.style.whiteSpace = 'nowrap'
        nameShellNode.style.overflow = 'hidden'
        nameShellNode.style.verticalAlign = 'middle'

        nameNode.style.display = 'inline-block'
        nameNode.style.whiteSpace = 'nowrap'
        nameNode.style.verticalAlign = 'middle'

        suffixNode.style.verticalAlign = 'middle'

        return { nameShellNode, nameNode, suffixNode }
    }

    const measureFounderSocialNameWidth = (titleNode, nameNode, text) => {
        if (!titleNode || !nameNode) return 1

        const measureNode = nameNode.cloneNode(true)
        measureNode.textContent = text
        measureNode.style.position = 'absolute'
        measureNode.style.left = '0'
        measureNode.style.top = '0'
        measureNode.style.visibility = 'hidden'
        measureNode.style.pointerEvents = 'none'
        measureNode.style.width = 'auto'
        measureNode.style.maxWidth = 'none'
        measureNode.style.transform = 'none'
        titleNode.appendChild(measureNode)
        const width = Math.max(
            1,
            measureNode.scrollWidth ||
            measureNode.offsetWidth ||
            Number.parseFloat(window.getComputedStyle(measureNode).width || '') ||
            1
        )
        measureNode.remove()
        return width
    }

    const animateFounderSocialNameSwap = (titleNode, nextTitle, timeline = null, startAt = 0) => {
        if (!titleNode) return

        const nodes = ensureFounderSocialTitleNodes(titleNode)
        if (!nodes) return

        const { nameShellNode, nameNode, suffixNode } = nodes
        if (!nameShellNode) return
        const nextParts = splitFounderSocialTitle(nextTitle)

        const currentName = normalizeFounderText(nameNode.textContent)
        const nextName = normalizeFounderText(nextParts.name)
        const nextSuffixText = nextParts.suffix ? ` ${nextParts.suffix}` : ''
        const currentMeasuredWidth = measureFounderSocialNameWidth(titleNode, nameNode, currentName)
        const nextMeasuredWidth = measureFounderSocialNameWidth(titleNode, nameNode, nextName)

        if (!timeline) {
            nameNode.textContent = nextName
            suffixNode.textContent = nextSuffixText
            nameShellNode.style.width = `${nextMeasuredWidth}px`
            nameShellNode.style.willChange = 'auto'
            gsap.set(nameNode, { y: 0, autoAlpha: 1, scale: 1 })
            return
        }

        if (currentName === nextName) {
            suffixNode.textContent = nextSuffixText
            nameShellNode.style.width = `${currentMeasuredWidth}px`
            return
        }

        gsap.killTweensOf([nameNode, nameShellNode])
        const currentWidth = currentMeasuredWidth
        const nextWidth = nextMeasuredWidth
        nameShellNode.style.width = `${currentWidth}px`
        nameShellNode.style.willChange = 'width'
        suffixNode.textContent = nextSuffixText

        timeline.to(nameShellNode, {
            width: nextWidth,
            duration: 0.44,
            ease: 'power2.inOut',
            force3D: true,
            overwrite: false,
            onComplete: () => {
                nameShellNode.style.width = `${nextWidth}px`
                nameShellNode.style.willChange = 'auto'
            },
        }, startAt)

        animateTextSwap(nameNode, nextName, timeline, startAt, {
            inY: 8,
            outY: -8,
            inDelay: 0.06,
            durationOut: 0.34,
            durationIn: 0.44,
        })
    }

    const applySocialContent = (founder, timeline = null, startAt = 0) => {
        socialCards.forEach((_, index) => {
            const social = founder.socials[index]
            if (!social) return

            if (socialTitles[index]) {
                animateFounderSocialNameSwap(socialTitles[index], social.title, timeline, startAt)
            }
            if (socialIcons[index]) {
                socialIcons[index].src = social.icon
                socialIcons[index].alt = `${founder.name} social icon`
            }
            if (socialHandles[index]) {
                animateTextSwap(socialHandles[index], social.handle, timeline, startAt, {
                    inY: 16,
                    outY: -10,
                    durationOut: 0.38,
                    durationIn: 0.5,
                })
            }
            if (socialMetrics[index]) {
                animateTextSwap(socialMetrics[index], social.metric, timeline, startAt, {
                    inY: 16,
                    outY: -10,
                    durationOut: 0.38,
                    durationIn: 0.5,
                })
            }
        })
    }

    const applyFounderContent = founder => {
        applyQuoteContent(founder)
        applySocialContent(founder)
    }

    const clearContentGhosts = () => {
        root.querySelectorAll('[data-founder-content-ghost]').forEach(node => node.remove())
    }

    const updatePopupContent = founder => {
        if (!popupNameNode || !popupDescriptionNode) return
        popupNameNode.textContent = founder.name
        popupDescriptionNode.textContent = founder.quoteFull
    }

    const openFounderPopup = () => {
        if (!popup || !popupInner || !popupNameNode || !popupDescriptionNode) return

        const founder = founders[activeIndex]
        updatePopupContent(founder)

        if (!popupTimeline) {
            gsap.set([popup, popupInner], { autoAlpha: 0 })
            gsap.set(popup, { display: 'none' })

            popupTimeline = gsap.timeline({ paused: true })
                .to(popup, {
                    duration: 0.32,
                    autoAlpha: 1,
                    display: 'block',
                })
                .fromTo(popupInner, {
                    scale: 0.94,
                    autoAlpha: 0,
                    y: 20,
                    force3D: true,
                }, {
                    scale: 1,
                    autoAlpha: 1,
                    y: 0,
                    duration: 0.36,
                    ease: 'power2.out',
                    force3D: true,
                }, '<')

            popupTimeline.eventCallback('onReverseComplete', () => {
                gsap.set(popup, { display: 'none' })
                isPopupOpen = false
                if (scroll && typeof scroll.start === 'function') {
                    scroll.start()
                }
            })
        }

        popup.setAttribute('aria-hidden', 'false')
        isPopupOpen = true

        if (scroll && typeof scroll.stop === 'function') {
            scroll.stop()
        }

        popupTimeline.play(0)
    }

    const closeFounderPopup = () => {
        if (!popup || !popupTimeline || !isPopupOpen) return
        popup.setAttribute('aria-hidden', 'true')
        popupTimeline.reverse()
    }

    const goToSlide = direction => {
        if (slideTimeline || isSlideAnimating) return

        clearContentGhosts()

        const nextIndex = (activeIndex + direction + founders.length) % founders.length
        if (nextIndex === activeIndex) return
        isSlideAnimating = true
        setFounderNavLocked(true)

        imageLayers.forEach((image, index) => {
            gsap.set(image, {
                autoAlpha: index === activeIndex ? 1 : 0,
                y: index === activeIndex ? 0 : 10,
            })
        })
        gsap.set(quoteTargets, { autoAlpha: 1, y: 0, x: 0 })
        gsap.set(cardTargets, { autoAlpha: 1, y: 0, x: 0, scale: 1, filter: 'none' })

        const outgoingImage = imageLayers[activeIndex]
        const incomingImage = imageLayers[nextIndex]
        const nextFounder = founders[nextIndex]

        activeIndex = nextIndex

        slideTimeline = gsap.timeline({
            defaults: { overwrite: true, ease: 'nbs' },
            onComplete: () => {
                slideTimeline = null
                isSlideAnimating = false
                setFounderNavLocked(false)
            },
            onInterrupt: () => {
                slideTimeline = null
                isSlideAnimating = false
                setFounderNavLocked(false)
            },
        })

        const directionSign = direction >= 0 ? 1 : -1

        slideTimeline.to(outgoingImage, {
            autoAlpha: 0,
            y: directionSign > 0 ? -10 : 10,
            scale: 1.012,
            duration: 0.52,
            ease: 'nbs',
            force3D: true,
        }, 0)

        slideTimeline.set(incomingImage, {
            autoAlpha: 0,
            y: directionSign > 0 ? 10 : -10,
            scale: 0.988,
        }, 0.08)

        slideTimeline.add(() => {
            applySocialContent(nextFounder, slideTimeline, 0.1)
        }, 0.08)

        slideTimeline.add(() => {
            const quoteParent = quoteNode.parentElement
            const parentComputedStyle = quoteParent ? window.getComputedStyle(quoteParent) : null
            const quoteRect = quoteNode.getBoundingClientRect()
            const parentRect = quoteParent ? quoteParent.getBoundingClientRect() : null

            if (quoteParent && parentRect && quoteRect) {
                if (parentComputedStyle && parentComputedStyle.position === 'static') {
                    quoteParent.style.position = 'relative'
                }

                const ghostQuote = quoteNode.cloneNode(true)
                ghostQuote.removeAttribute('data-founder-quote')
                ghostQuote.removeAttribute('data-founder-quote-2')
                ghostQuote.setAttribute('data-founder-content-ghost', '')
                ghostQuote.setAttribute('aria-hidden', 'true')
                ghostQuote.style.position = 'absolute'
                ghostQuote.style.left = `${quoteRect.left - parentRect.left}px`
                ghostQuote.style.top = `${quoteRect.top - parentRect.top}px`
                ghostQuote.style.width = `${quoteRect.width}px`
                ghostQuote.style.height = `${quoteRect.height}px`
                ghostQuote.style.margin = '0'
                ghostQuote.style.pointerEvents = 'none'
                ghostQuote.style.zIndex = '1'
                quoteParent.appendChild(ghostQuote)

                const quoteOutRotate = directionSign > 0 ? -3 : 3
                const quoteInRotate = -quoteOutRotate * 0.8

                applyQuoteContent(nextFounder, slideTimeline, 0.08)
                gsap.set(quoteNode, {
                    autoAlpha: 0,
                    y: 24,
                    x: directionSign > 0 ? 14 : -14,
                    rotateZ: quoteInRotate,
                    scale: 0.97,
                    filter: 'blur(14px)',
                    transformOrigin: '50% 100%',
                })

                slideTimeline.to(ghostQuote, {
                    autoAlpha: 0,
                    y: -22,
                    x: directionSign > 0 ? -10 : 10,
                    rotateZ: quoteOutRotate,
                    scale: 1.03,
                    filter: 'blur(10px)',
                    duration: 0.46,
                    ease: 'power2.inOut',
                    onComplete: () => {
                        ghostQuote.remove()
                    },
                }, 0.1)

                slideTimeline.to(quoteNode, {
                    autoAlpha: 1,
                    y: 0,
                    x: 0,
                    rotateZ: 0,
                    scale: 1,
                    filter: 'blur(0px)',
                    duration: 0.62,
                    ease: 'power3.out',
                    force3D: true,
                }, 0.18)
                animateSecondaryQuotesIn(slideTimeline, 0.2)
            } else {
                const quoteInRotate = directionSign > 0 ? 2 : -2

                applyQuoteContent(nextFounder, slideTimeline, 0.08)
                gsap.set(quoteNode, {
                    autoAlpha: 0,
                    y: 20,
                    x: directionSign > 0 ? 10 : -10,
                    rotateZ: quoteInRotate,
                    scale: 0.978,
                    filter: 'blur(10px)',
                    transformOrigin: '50% 100%',
                })
                slideTimeline.to(quoteNode, {
                    autoAlpha: 1,
                    y: 0,
                    x: 0,
                    rotateZ: 0,
                    scale: 1,
                    filter: 'blur(0px)',
                    duration: 0.56,
                    ease: 'power3.out',
                    force3D: true,
                }, 0.14)
                animateSecondaryQuotesIn(slideTimeline, 0.16)
            }
        }, 0.08)

        slideTimeline.to(incomingImage, {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: 0.68,
            ease: 'nbs',
            force3D: true,
        }, 0.12)

        if (isPopupOpen) {
            updatePopupContent(nextFounder)
        }
    }

    imageLayers.forEach((image, index) => {
        image.classList.remove('invisible')
        gsap.set(image, {
            autoAlpha: index === activeIndex ? 1 : 0,
            y: index === activeIndex ? 0 : 10,
            scale: 1,
        })
    })

    applyFounderContent(founders[activeIndex])
    setFounderNavLocked(false)
    gsap.set(quoteTargets, { autoAlpha: 1, y: 0, x: 0, scale: 1 })
    gsap.set(cardTargets, { autoAlpha: 1, y: 0, x: 0, scale: 1, filter: 'none' })

    const onNextClick = event => {
        event.preventDefault()
        goToSlide(1)
    }

    const onPrevClick = event => {
        event.preventDefault()
        goToSlide(-1)
    }

    const onToggleQuote = event => {
        event.preventDefault()
        if (slideTimeline) return
        openFounderPopup()
    }

    const onPopupClick = event => {
        if (!popupInner || popupInner.contains(event.target)) return
        closeFounderPopup()
    }

    const onPopupEscape = event => {
        if (event.key !== 'Escape') return
        if (!isPopupOpen) return
        closeFounderPopup()
    }

    const onPopupCloseClick = event => {
        event.preventDefault()
        closeFounderPopup()
    }

    const onFounderSliderResize = () => {
        applyQuoteClamp()
        socialTitles.forEach(title => {
            const nodes = ensureFounderSocialTitleNodes(title)
            if (!nodes) return

            const text = normalizeFounderText(nodes.nameNode.textContent)
            const width = measureFounderSocialNameWidth(title, nodes.nameNode, text)
            nodes.nameShellNode.style.width = `${width}px`
            nodes.nameShellNode.style.willChange = 'auto'
            gsap.set(nodes.nameNode, { y: 0, autoAlpha: 1, scale: 1 })
        })
    }

    nextButton.addEventListener('click', onNextClick)
    prevButton.addEventListener('click', onPrevClick)
    quoteToggleButton.addEventListener('click', onToggleQuote)
    popupCloseButtons.forEach(button => {
        button.addEventListener('click', onPopupCloseClick)
    })
    if (popup) {
        popup.addEventListener('click', onPopupClick)
    }
    document.addEventListener('keydown', onPopupEscape)
    window.addEventListener('resize', onFounderSliderResize)

    if (window.addDisposable) {
        addDisposable(() => {
            if (slideTimeline) {
                slideTimeline.kill()
                slideTimeline = null
            }
            isSlideAnimating = false
            setFounderNavLocked(false)
            clearContentGhosts()

            nextButton.removeEventListener('click', onNextClick)
            prevButton.removeEventListener('click', onPrevClick)
            quoteToggleButton.removeEventListener('click', onToggleQuote)
            popupCloseButtons.forEach(button => {
                button.removeEventListener('click', onPopupCloseClick)
            })
            if (popup) {
                popup.removeEventListener('click', onPopupClick)
            }
            document.removeEventListener('keydown', onPopupEscape)
            window.removeEventListener('resize', onFounderSliderResize)
        })
    }
}

function initMainVideoButtons() {
    const buttons = document.querySelectorAll('.main_video_btn')
    if (!buttons.length) return

    const ensureVideoReady = video => {
        if (!video) return

        const source = (video.dataset.videoSrc || '').trim()
        if (!video.getAttribute('src') && source) {
            video.setAttribute('src', source)
            try {
                video.load()
            } catch (err) {}
        }
    }

    const fadeVideoVolume = (video, targetVolume) => {
        if (!video) return
        const safeTarget = gsap.utils.clamp(0, 1, Number(targetVolume) || 0)

        gsap.killTweensOf(video, 'volume')

        if (safeTarget > 0) {
            video.muted = false
            video.defaultMuted = false
        }

        gsap.to(video, {
            volume: safeTarget,
            duration: 0.38,
            ease: 'power2.out',
            overwrite: true,
            onComplete: () => {
                if (safeTarget <= 0) {
                    video.muted = true
                    video.defaultMuted = true
                    video.volume = 0
                }
            }
        })
    }

    buttons.forEach(button => {
        if (button.hasAttribute('data-main-video-popup-src')) return
        if (button.dataset.mainVideoBtnBound === '1') return
        button.dataset.mainVideoBtnBound = '1'

        const onClickMainVideoBtn = () => {
            const sectionRoot = button.closest('#top-first-section-courses') || document
            const targetSelector = button.getAttribute('data-main-video-target') || '#course_video_top [data-main-video-primary], #course_video_top video'
            const targetVideos = Array.from(sectionRoot.querySelectorAll(targetSelector))
            const uniqueVideos = [...new Set(targetVideos)]
            if (!uniqueVideos.length) return

            const shouldUnmute = uniqueVideos.some(video => video.muted || video.volume < 0.5)

            uniqueVideos.forEach(video => {
                ensureVideoReady(video)

                if (shouldUnmute) {
                    const playPromise = video.play()
                    if (playPromise && typeof playPromise.catch === 'function') {
                        playPromise.catch(() => {})
                    }
                    fadeVideoVolume(video, 1)
                } else {
                    fadeVideoVolume(video, 0)
                }
            })
        }

        button.addEventListener('click', onClickMainVideoBtn)

        if (window.addDisposable) {
            addDisposable(() => {
                button.removeEventListener('click', onClickMainVideoBtn)
            })
        }
    })
}

function initMainVideoPopup() {
    const popup = document.getElementById('course_video_popup')
    const buttons = document.querySelectorAll('.main_video_btn[data-main-video-popup-src]')
    if (!popup || !buttons.length) return

    const inner = popup.querySelector('.inner_video_popup')
    const closeButtons = popup.querySelectorAll('[data-close-main-video-popup]')
    const popupVideo = popup.querySelector('[data-main-video-popup-player]')
    const toggleButton = popup.querySelector('[data-main-video-popup-toggle]')
    const playIcon = popup.querySelector('[data-main-video-icon-play]')
    const pauseIcon = popup.querySelector('[data-main-video-icon-pause]')
    const progressTrack = popup.querySelector('[data-main-video-progress-track]')
    const progressFill = popup.querySelector('[data-main-video-progress-fill]')
    const progressThumb = popup.querySelector('[data-main-video-progress-thumb]')
    const currentLabel = popup.querySelector('[data-main-video-current]')
    const durationLabel = popup.querySelector('[data-main-video-duration]')

    if (!inner || !popupVideo || !toggleButton || !progressTrack || !progressFill || !progressThumb || !currentLabel || !durationLabel) {
        return
    }

    let isOpen = false
    let isSeeking = false
    let shouldResumeAfterSeek = false
    let shouldStopOnClose = false

    gsap.set([popup, inner], { autoAlpha: 0 })
    gsap.set(popup, { display: 'none' })

    const popupTimeline = gsap.timeline({ paused: true })
        .to(popup, {
            duration: 0.45,
            autoAlpha: 1,
            display: 'block'
        })
        .fromTo(inner, {
            scale: 0.96,
            autoAlpha: 0,
            y: 20
        }, {
            scale: 1,
            autoAlpha: 1,
            y: 0,
            duration: 0.45
        }, '<')

    popupTimeline.eventCallback('onReverseComplete', () => {
        if (shouldStopOnClose) {
            shouldStopOnClose = false
            try {
                popupVideo.pause()
                popupVideo.currentTime = 0
            } catch (err) {}
            setToggleState(false)
            updateProgressUI()
        }
        gsap.set(popup, { display: 'none' })
    })

    const formatTime = seconds => {
        const value = Math.max(0, Number(seconds) || 0)
        const total = Math.floor(value)
        const mins = Math.floor(total / 60)
        const secs = total % 60
        return `${mins}:${String(secs).padStart(2, '0')}`
    }

    const setToggleState = isPlaying => {
        playIcon.classList.toggle('hidden', isPlaying)
        pauseIcon.classList.toggle('hidden', !isPlaying)
        toggleButton.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video')
    }

    const updateProgressUI = () => {
        const duration = Number.isFinite(popupVideo.duration) ? popupVideo.duration : 0
        const current = Math.min(Math.max(0, popupVideo.currentTime || 0), duration || 0)
        const ratio = duration > 0 ? current / duration : 0
        const percent = `${ratio * 100}%`

        progressFill.style.width = percent
        progressThumb.style.left = percent
        currentLabel.textContent = formatTime(current)
        durationLabel.textContent = formatTime(current)
    }

    const ensurePopupSource = button => {
        if (!button) return false

        let source = (button.getAttribute('data-main-video-popup-src') || '').trim()
        let poster = (button.getAttribute('data-main-video-popup-poster') || '').trim()

        if (!source) {
            const previewVideo = button.querySelector('[data-main-video-preview], video')
            if (previewVideo) {
                source = (previewVideo.dataset.videoSrc || previewVideo.getAttribute('src') || '').trim()
                if (!poster) {
                    poster = (previewVideo.getAttribute('poster') || '').trim()
                }
            }
        }

        if (!source) return false

        if (popupVideo.getAttribute('src') !== source) {
            popupVideo.setAttribute('src', source)
            try {
                popupVideo.load()
            } catch (err) {}
        }

        if (poster) {
            popupVideo.setAttribute('poster', poster)
        }

        return true
    }

    const playPopupVideo = () => {
        popupVideo.muted = false
        popupVideo.defaultMuted = false
        popupVideo.volume = 1

        const playPromise = popupVideo.play()
        if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {
                popupVideo.muted = true
                popupVideo.defaultMuted = true
                setToggleState(false)
            })
        }
    }

    const openPopup = button => {
        if (!ensurePopupSource(button)) return

        shouldStopOnClose = false
        isOpen = true
        popup.setAttribute('aria-hidden', 'false')
        popupTimeline.play(0)
        setToggleState(true)
        updateProgressUI()

        if (scroll && typeof scroll.stop === 'function') {
            scroll.stop()
        }

        playPopupVideo()
    }

    const closePopup = () => {
        if (!isOpen && popupTimeline.progress() === 0) return

        isOpen = false
        shouldStopOnClose = true
        popup.setAttribute('aria-hidden', 'true')
        popupTimeline.reverse()

        if (scroll && typeof scroll.start === 'function') {
            scroll.start()
        }
    }

    const seekFromClientX = clientX => {
        const duration = Number.isFinite(popupVideo.duration) ? popupVideo.duration : 0
        if (!duration) return

        const rect = progressTrack.getBoundingClientRect()
        if (!rect.width) return

        const ratio = gsap.utils.clamp(0, 1, (clientX - rect.left) / rect.width)
        popupVideo.currentTime = ratio * duration
        updateProgressUI()
    }

    const onSeekMove = event => {
        if (!isSeeking) return
        if (!Number.isFinite(event.clientX)) return
        seekFromClientX(event.clientX)
    }

    const onSeekEnd = () => {
        if (!isSeeking) return

        isSeeking = false
        window.removeEventListener('pointermove', onSeekMove)
        window.removeEventListener('pointerup', onSeekEnd)
        window.removeEventListener('pointercancel', onSeekEnd)

        if (shouldResumeAfterSeek) {
            playPopupVideo()
        }
    }

    const onSeekStart = event => {
        const duration = Number.isFinite(popupVideo.duration) ? popupVideo.duration : 0
        if (!duration) return

        event.preventDefault()
        isSeeking = true
        shouldResumeAfterSeek = !popupVideo.paused

        try {
            popupVideo.pause()
        } catch (err) {}

        seekFromClientX(event.clientX)

        window.addEventListener('pointermove', onSeekMove)
        window.addEventListener('pointerup', onSeekEnd)
        window.addEventListener('pointercancel', onSeekEnd)
    }

    const onTogglePlay = event => {
        if (event) event.preventDefault()

        if (popupVideo.paused || popupVideo.ended) {
            playPopupVideo()
        } else {
            popupVideo.pause()
        }
    }

    const onVideoClickToggle = event => {
        if (!isOpen) return
        if (event?.target?.closest('[data-main-video-progress-track], [data-main-video-popup-toggle], [data-close-main-video-popup]')) return
        onTogglePlay()
    }

    const onPopupClick = event => {
        if (!inner.contains(event.target)) {
            closePopup()
        }
    }

    const onEscClose = event => {
        if (event.key !== 'Escape') return
        if (popupTimeline.progress() === 0) return
        closePopup()
    }

    const onVideoPlay = () => setToggleState(true)
    const onVideoPause = () => setToggleState(false)
    const onVideoEnded = () => {
        setToggleState(false)
        updateProgressUI()
    }

    buttons.forEach(button => {
        if (button.dataset.mainVideoPopupBound === '1') return
        button.dataset.mainVideoPopupBound = '1'

        const onClickMainVideoPopup = event => {
            event.preventDefault()
            openPopup(button)
        }

        button.addEventListener('click', onClickMainVideoPopup)

        if (window.addDisposable) {
            addDisposable(() => {
                button.removeEventListener('click', onClickMainVideoPopup)
            })
        }
    })

    const onCloseButtonClick = event => {
        event.preventDefault()
        closePopup()
    }

    closeButtons.forEach(button => {
        button.addEventListener('click', onCloseButtonClick)
    })

    toggleButton.addEventListener('click', onTogglePlay)
    progressTrack.addEventListener('pointerdown', onSeekStart)
    popup.addEventListener('click', onPopupClick)
    document.addEventListener('keydown', onEscClose)

    popupVideo.addEventListener('timeupdate', updateProgressUI)
    popupVideo.addEventListener('loadedmetadata', updateProgressUI)
    popupVideo.addEventListener('durationchange', updateProgressUI)
    popupVideo.addEventListener('play', onVideoPlay)
    popupVideo.addEventListener('pause', onVideoPause)
    popupVideo.addEventListener('ended', onVideoEnded)
    popupVideo.addEventListener('click', onVideoClickToggle)

    if (window.addDisposable) {
        addDisposable(() => {
            closeButtons.forEach(button => {
                button.removeEventListener('click', onCloseButtonClick)
            })
            toggleButton.removeEventListener('click', onTogglePlay)
            progressTrack.removeEventListener('pointerdown', onSeekStart)
            popup.removeEventListener('click', onPopupClick)
            document.removeEventListener('keydown', onEscClose)

            popupVideo.removeEventListener('timeupdate', updateProgressUI)
            popupVideo.removeEventListener('loadedmetadata', updateProgressUI)
            popupVideo.removeEventListener('durationchange', updateProgressUI)
            popupVideo.removeEventListener('play', onVideoPlay)
            popupVideo.removeEventListener('pause', onVideoPause)
            popupVideo.removeEventListener('ended', onVideoEnded)
            popupVideo.removeEventListener('click', onVideoClickToggle)

            onSeekEnd()
            popupTimeline.kill()
        })
    }
}

function initCursorFollow(scope = document) {
    const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches
    if (!supportsHover) return

    const wrappers = scope.querySelectorAll(CURSOR_FOLLOW_WRAPPER_SELECTOR)
    if (!wrappers.length) return

    const resolveIconForWrapper = wrapper => {
        const targetSelector = wrapper.getAttribute('data-cursor-follow-target')
        if (targetSelector) {
            const inScope = scope.querySelector(targetSelector)
            if (inScope) return inScope

            const inDocument = document.querySelector(targetSelector)
            if (inDocument) return inDocument
        }

        const nestedIcon = wrapper.querySelector(CURSOR_FOLLOW_ICON_SELECTOR)
        if (nestedIcon) return nestedIcon

        const parent = wrapper.parentElement
        if (parent) {
            const iconsInParent = parent.querySelectorAll(CURSOR_FOLLOW_ICON_SELECTOR)
            if (iconsInParent.length === 1) return iconsInParent[0]
        }

        if (wrappers.length === 1) {
            const iconsInScope = scope.querySelectorAll(CURSOR_FOLLOW_ICON_SELECTOR)
            if (iconsInScope.length === 1) return iconsInScope[0]
        }

        return null
    }

    wrappers.forEach(wrapper => {
        if (wrapper.dataset.cursorFollowBound === '1') return

        const icon = resolveIconForWrapper(wrapper)
        if (!icon) return
        const iconScaleTarget = icon.querySelector(CURSOR_FOLLOW_INNER_SELECTOR) || icon

        wrapper.dataset.cursorFollowBound = '1'

        icon.style.pointerEvents = 'none'
        const attrLag = Number.parseFloat(wrapper.dataset.cursorFollowLag || '')
        const followLerp = Number.isFinite(attrLag)
            ? gsap.utils.clamp(0.06, 0.45, attrLag)
            : 0.16
        const attrLeaveLag = Number.parseFloat(wrapper.dataset.cursorFollowLeaveLag || '')
        const leaveLerp = Number.isFinite(attrLeaveLag)
            ? gsap.utils.clamp(0.04, 0.35, attrLeaveLag)
            : 0.12
        const initialScaleRaw = Number.parseFloat(gsap.getProperty(iconScaleTarget, 'scale'))
        const initialScale = Number.isFinite(initialScaleRaw) && initialScaleRaw > 0
            ? initialScaleRaw
            : 1
        let targetX = 0
        let targetY = 0
        let currentX = 0
        let currentY = 0
        let isInside = false
        let rafId = 0
        let lastClientX = null
        let lastClientY = null

        const startLoop = () => {
            if (rafId) return

            const tick = () => {
                const lerp = isInside ? followLerp : leaveLerp
                currentX += (targetX - currentX) * lerp
                currentY += (targetY - currentY) * lerp

                gsap.set(icon, { x: currentX, y: currentY })

                const delta = Math.abs(targetX - currentX) + Math.abs(targetY - currentY)
                if (isInside || delta > 0.2) {
                    rafId = requestAnimationFrame(tick)
                } else {
                    rafId = 0
                }
            }

            rafId = requestAnimationFrame(tick)
        }

        const onMove = event => {
            if (!Number.isFinite(event.clientX) || !Number.isFinite(event.clientY)) return

            lastClientX = event.clientX
            lastClientY = event.clientY

            const rect = wrapper.getBoundingClientRect()
            const iconRect = icon.getBoundingClientRect()
            const wrapperCenterX = rect.left + rect.width / 2
            const wrapperCenterY = rect.top + rect.height / 2
            const iconCurrentCenterX = iconRect.left + iconRect.width / 2
            const iconCurrentCenterY = iconRect.top + iconRect.height / 2
            const baseCenterX = iconCurrentCenterX - currentX
            const baseCenterY = iconCurrentCenterY - currentY

            let targetCenterX = event.clientX
            let targetCenterY = event.clientY

            const attrStrength = Number.parseFloat(wrapper.dataset.cursorFollowStrength || '')
            const strength = Number.isFinite(attrStrength)
                ? gsap.utils.clamp(0.15, 2, attrStrength)
                : 1
            targetCenterX = wrapperCenterX + (targetCenterX - wrapperCenterX) * strength
            targetCenterY = wrapperCenterY + (targetCenterY - wrapperCenterY) * strength

            const iconHalfW = iconRect.width / 2
            const iconHalfH = iconRect.height / 2
            const attrEdgePadding = Number.parseFloat(wrapper.dataset.cursorFollowEdgePadding || '')
            let edgePadding = 0
            if (Number.isFinite(attrEdgePadding)) {
                edgePadding = Math.max(0, attrEdgePadding)
            } else {
                const computed = window.getComputedStyle(wrapper)
                const radiusTopLeft = Number.parseFloat(computed.borderTopLeftRadius || '') || 0
                const radiusTopRight = Number.parseFloat(computed.borderTopRightRadius || '') || 0
                const radiusBottomRight = Number.parseFloat(computed.borderBottomRightRadius || '') || 0
                const radiusBottomLeft = Number.parseFloat(computed.borderBottomLeftRadius || '') || 0
                edgePadding = Math.max(radiusTopLeft, radiusTopRight, radiusBottomRight, radiusBottomLeft, 0)
            }

            const minCenterX = rect.left + iconHalfW + edgePadding
            const maxCenterX = rect.right - iconHalfW - edgePadding
            const minCenterY = rect.top + iconHalfH + edgePadding
            const maxCenterY = rect.bottom - iconHalfH - edgePadding

            if (minCenterX <= maxCenterX) {
                targetCenterX = gsap.utils.clamp(minCenterX, maxCenterX, targetCenterX)
            } else {
                targetCenterX = wrapperCenterX
            }

            if (minCenterY <= maxCenterY) {
                targetCenterY = gsap.utils.clamp(minCenterY, maxCenterY, targetCenterY)
            } else {
                targetCenterY = wrapperCenterY
            }

            let x = targetCenterX - baseCenterX
            let y = targetCenterY - baseCenterY

            const attrMax = Number.parseFloat(wrapper.dataset.cursorFollowMax || '')
            if (Number.isFinite(attrMax)) {
                const maxOffset = Math.max(16, attrMax)
                x = gsap.utils.clamp(-maxOffset, maxOffset, x)
                y = gsap.utils.clamp(-maxOffset, maxOffset, y)
            }

            let clampedCenterX = baseCenterX + x
            let clampedCenterY = baseCenterY + y
            if (minCenterX <= maxCenterX) {
                clampedCenterX = gsap.utils.clamp(minCenterX, maxCenterX, clampedCenterX)
            }
            if (minCenterY <= maxCenterY) {
                clampedCenterY = gsap.utils.clamp(minCenterY, maxCenterY, clampedCenterY)
            }
            x = clampedCenterX - baseCenterX
            y = clampedCenterY - baseCenterY

            targetX = x
            targetY = y
            startLoop()
        }

        const onEnter = event => {
            isInside = true
            onMove(event)
        }

        const onLeave = () => {
            isInside = false
            targetX = 0
            targetY = 0
            startLoop()
        }

        const onScrollRecalculate = () => {
            if (!wrapper.isConnected) return

            if (!wrapper.matches(':hover')) {
                if (isInside) onLeave()
                return
            }

            if (!Number.isFinite(lastClientX) || !Number.isFinite(lastClientY)) return

            if (!isInside) {
                isInside = true
            }
            onMove({ clientX: lastClientX, clientY: lastClientY })
        }

        wrapper.addEventListener('pointerenter', onEnter)
        wrapper.addEventListener('pointermove', onMove)
        wrapper.addEventListener('pointerleave', onLeave)
        window.addEventListener('scroll', onScrollRecalculate)
        if (mainWrapper) {
            mainWrapper.addEventListener('scroll', onScrollRecalculate)
        }

        if (window.addDisposable) {
            addDisposable(() => {
                delete wrapper.dataset.cursorFollowBound
                wrapper.removeEventListener('pointerenter', onEnter)
                wrapper.removeEventListener('pointermove', onMove)
                wrapper.removeEventListener('pointerleave', onLeave)
                window.removeEventListener('scroll', onScrollRecalculate)
                if (mainWrapper) {
                    mainWrapper.removeEventListener('scroll', onScrollRecalculate)
                }
                if (rafId) {
                    cancelAnimationFrame(rafId)
                    rafId = 0
                }
                gsap.set(iconScaleTarget, { scale: initialScale })
                onLeave()
            })
        }
    })
}

function initObserverHub() {
  if (window.__observerHubInit) return;
  window.__observerHubInit = !0;
  const t = new Map();
  ((window.getObserver = function (e = {}) {
    const a = (function (t = {}) {
      const e = Array.isArray(t.threshold)
          ? t.threshold.join(",")
          : (t.threshold ?? 0),
        a = t.rootMargin ?? "0px 0px 0px 0px";
      return JSON.stringify({ t: e, r: a });
    })(e);
    if (t.has(a)) return t.get(a);
    const r = new IntersectionObserver((t) => {
      for (let e = 0; e < t.length; e++) {
        const a = t[e],
          r = a.target.__ioCallbacks;
        if (r) for (let t = 0; t < r.length; t++) r[t](a);
      }
    }, e);
    return (t.set(a, r), r);
  }),
    (window.observeWith = function (t, e = {}, a) {
      if (!t || "function" != typeof a) return () => {};
      const r = getObserver(e);
      ((t.__ioCallbacks = t.__ioCallbacks || []),
        t.__ioCallbacks.push(a),
        r.observe(t));
      const n = () => {
        t.__ioCallbacks &&
          (t.__ioCallbacks = t.__ioCallbacks.filter((t) => t !== a));
        try {
          r.unobserve(t);
        } catch (t) {}
      };
      return window.addDisposable ? window.addDisposable(n) : n;
    }));
}

function getCurrentScrollPosition() {
    if (scroll && typeof scroll.actualScroll === 'number') {
        return scroll.actualScroll
    }

    if (window.innerWidth < 1280 && mainWrapper) {
        return mainWrapper.scrollTop || 0
    }

    return window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0
}

function getApplyFormViewportOffset() {
    if (window.innerWidth >= 1280) {
        return Math.round(Math.min(56, Math.max(36, window.innerHeight * 0.05)))
    }

    return 24
}

function getCertificateViewportOffset() {
    if (window.innerWidth >= 1280) {
        return Math.round(Math.max(280, Math.min(window.innerHeight * 0.58, 620)))
    }

    return 72
}

function getApplyFormTarget() {
    return document.querySelector(APPLY_FORM_TITLE_SELECTOR)
}

function getCertificateIdTarget() {
    return document.querySelector(CERTIFICATE_ID_TARGET_SELECTOR)
}

function waitForApplyFormAssets() {
    const section = document.querySelector(APPLY_FORM_SECTION_SELECTOR)
    const media = section?.querySelector(APPLY_FORM_MEDIA_SELECTOR)
    const waits = []

    if (document.fonts?.ready) {
        waits.push(document.fonts.ready.catch(() => {}))
    }

    if (media?.decode) {
        waits.push(media.decode().catch(() => {}))
    } else if (media && !media.complete) {
        waits.push(new Promise(resolve => {
            media.addEventListener('load', resolve, { once: true })
            media.addEventListener('error', resolve, { once: true })
        }))
    }

    return Promise.allSettled(waits)
}

function waitForWindowLoad() {
    if (document.readyState === 'complete') {
        return Promise.resolve()
    }

    return new Promise(resolve => {
        window.addEventListener('load', resolve, { once: true })
    })
}

function waitForFrames(count = 1) {
    return new Promise(resolve => {
        const step = () => {
            count -= 1
            if (count <= 0) {
                resolve()
                return
            }

            requestAnimationFrame(step)
        }

        requestAnimationFrame(step)
    })
}

function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

function isApplyFormAligned(tolerance = 8) {
    const target = getApplyFormTarget()
    if (!target) return false

    const viewportOffset = getApplyFormViewportOffset()
    const delta = Math.abs(target.getBoundingClientRect().top - viewportOffset)
    return delta <= tolerance
}

async function stabilizeApplyFormPosition(requestId, { maxIterations = 14, delayMs = 120 } = {}) {
    let stablePasses = 0

    for (let iteration = 0; iteration < maxIterations; iteration += 1) {
        if (requestId !== applyFormNavigationRequestId) return false

        ScrollTrigger.refresh()
        await waitForFrames(2)

        if (requestId !== applyFormNavigationRequestId) return false

        scrollToApplyForm({ immediate: true })
        await waitForFrames(2)

        if (requestId !== applyFormNavigationRequestId) return false

        if (isApplyFormAligned()) {
            stablePasses += 1
            if (stablePasses >= 3) {
                return true
            }
        } else {
            stablePasses = 0
        }

        await delay(delayMs)
    }

    return isApplyFormAligned(16)
}

function scrollToApplyForm({ immediate = false } = {}) {
    return scrollToTargetElement(getApplyFormTarget(), {
        immediate,
        viewportOffset: getApplyFormViewportOffset(),
    })
}

function scrollToCertificateId({ immediate = false } = {}) {
    return scrollToTargetElement(getCertificateIdTarget(), {
        immediate,
        viewportOffset: getCertificateViewportOffset(),
    })
}

function scrollToTargetElement(target, { immediate = false, viewportOffset = getApplyFormViewportOffset() } = {}) {
    if (!target) return false

    if (scroll && typeof scroll.scrollTo === 'function') {
        scroll.scrollTo(target, {
            duration: immediate ? 0 : 1,
            immediate,
            offset: -viewportOffset,
            lock: false,
            force: true,
        })
    } else {
        const targetY = Math.max(0, getCurrentScrollPosition() + target.getBoundingClientRect().top - viewportOffset)
        window.scrollTo({
            top: targetY,
            behavior: immediate ? 'auto' : 'smooth',
        })
    }

    return true
}

async function handleApplyFormHashNavigation({ immediate = false, initial = false } = {}) {
    if (!initial && location.hash !== APPLY_FORM_HASH && !pendingApplyFormHashScroll) {
        return
    }

    pendingApplyFormHashScroll = true
    const requestId = ++applyFormNavigationRequestId

    try {
        if (initial) {
            await waitForWindowLoad()
        }

        await waitForApplyFormAssets()
        await waitForFrames(2)

        if (requestId !== applyFormNavigationRequestId) return

        ScrollTrigger.refresh()
        await waitForFrames(1)

        if (requestId !== applyFormNavigationRequestId) return

        scrollToApplyForm({ immediate })

        if (initial) {
            await stabilizeApplyFormPosition(requestId)

            if (requestId !== applyFormNavigationRequestId) return

            history.replaceState(null, '', APPLY_FORM_HASH)
            window.__applyFormHashRequested = false
            releaseApplyFormPendingState()
            hidePreloader()
        }
    } catch (error) {
        if (initial) {
            releaseApplyFormPendingState()
            hidePreloader()
        }
    } finally {
        if (requestId === applyFormNavigationRequestId) {
            pendingApplyFormHashScroll = false
        }
    }
}

function initApplyFormHashNavigation() {
    const applyFormTarget = getApplyFormTarget()
    const certificateTarget = getCertificateIdTarget()

    if (!applyFormTarget && !certificateTarget) {
        if (pendingApplyFormHashScroll) {
            hidePreloader()
        }
        return
    }

    document.addEventListener('click', event => {
        const link = event.target.closest(`a[href$="${APPLY_FORM_HASH}"], a[href$="${CERTIFICATE_ID_HASH}"]`)
        if (!link) return

        const href = link.getAttribute('href') || ''
        const isApplyHashLink = href === APPLY_FORM_HASH || href.endsWith(APPLY_FORM_HASH)
        const isCertificateHashLink = href === CERTIFICATE_ID_HASH || href.endsWith(CERTIFICATE_ID_HASH)
        if (!isApplyHashLink && !isCertificateHashLink) return

        if (link.hasAttribute('data-certificate-hash-link') || isCertificateHashLink) {
            event.preventDefault()
            scrollToCertificateId({ immediate: false })
            return
        }

        event.preventDefault()
        pendingApplyFormHashScroll = true

        handleApplyFormHashNavigation({ immediate: false })
    })

    window.addEventListener('hashchange', () => {
        if (window.location.hash === CERTIFICATE_ID_HASH) {
            scrollToCertificateId({ immediate: false })
            return
        }

        if (window.location.hash === APPLY_FORM_HASH) {
            pendingApplyFormHashScroll = true
            handleApplyFormHashNavigation({ immediate: false })
        }
    })

    let resizeTimer = null
    window.addEventListener('resize', () => {
        if (window.location.hash !== APPLY_FORM_HASH) return

        clearTimeout(resizeTimer)
        resizeTimer = setTimeout(() => {
            scrollToApplyForm({ immediate: true })
        }, 120)
    })

    if (pendingApplyFormHashScroll) {
        handleApplyFormHashNavigation({ immediate: true, initial: true })
    } else if (window.location.hash === CERTIFICATE_ID_HASH) {
        releaseApplyFormPendingState()
        requestAnimationFrame(() => {
            scrollToCertificateId({ immediate: false })
        })
        setTimeout(() => {
            scrollToCertificateId({ immediate: false })
        }, 140)
    } else if (window.location.hash === APPLY_FORM_HASH) {
        releaseApplyFormPendingState()
        handleApplyFormHashNavigation({ immediate: true })
    } else {
        releaseApplyFormPendingState()
    }
}
